export default {
    "accountValidateMsg" : "Konto muss aus 6-30 Zeichen bestehen und enthält Buchstaben, Ziffern und Symbole (\".\", \"_\", \"@\"). Das erste Zeichen muss Ziffer oder Buchstabe sein.",
    "storeSuccess" : "Aufladung erfolgreich",
    "editAccountTips" : "Bitte einen gültigen Kontoname eingeben",
    "editPwdTips" : "Bitte ein gültiges Passwort eingeben",
    "editRepeatPwdTips" : "Bitte Ihr Passwort wieder eingeben",
    "pwdRepeatTips" : "Passwörter entsprechen nicht",
    "changePwdSucc" : "Ihr Passwort wurde geändert",
    "bindEmail" : "E-Mail binden",
    "verifyEmail" : "Kontosicherheitsprüfung",
    "errorVrifyCodeTips" : "Verifizierungscode Fehler",
    "slectQuessionTips" : "Eine Sicherheitsfrage auswählen?",
    "answerTips" : "Bitte die Antwort eingeben",
    "twoAnswerTips" : "Bitte erstellte Sicherheitsfragen auswählen und die richtigen Antworten eingeben",
    "realNameValidateTips" : "Echter Name (4 bis 60 Zeichen)",
    "phoneValidateTips" : "Handynummer (6 bis 18 Ziffern)",
    "areaSelectTips" : "Bitte Region auswählen",
    "iDCardValidataTips" : "ID-Nummer(1 bis 60 Ziffern)",
    "changeProfileSucc" : "Aktualisierte Info gespeichert",
    "editVrfCodeTips" : "Bitte Verifizierungscode eingeben",
    "securityQuestionTips" : "Erstellen Sie Sicherheitsfragen, um die Sicherheit Ihres Kontos zu verbessern. Wenn Sie Ihr Passwort vergessen haben, können Sie die Fragen beantworten, um das Passwort zurückzusetzen.",
    "validateQuessionTips" : "Bitte zwei verschiedene Fragen auswählen und verifizieren. Sie können die Fragen nach der Verifizeirung verändern.",
    "originPwd" : "Originales Passwort",
    "newPwd" : "Neues Passwort",
    "changePwdSuccess" : "Passwort geändert. Wir schlagen dir vor, jetzt wieder einzuloggen, um Ihren Fortschritt zu speichern.",
    "accountName" : "Kontoname",
    "password" : "Bitte gib dein Passwort ein.",
    "repeatPassword" : "Bitte wiederholen Sie Ihr Passwort",
    "findPwdTips" : "Bitte geben Sie das Konto ein, von dem Sie das Passwort abrufen möchten",
    "submit" : "Einreichen",
    "send" : "Senden",
    "modify" : "modifizieren",
    "haveAgree" : "Zustimmen",
    "and" : "und",
    "privacyPolicy" : "Datenschutzbestimmungen",
    "completeness" : "Abschluss",
    "gender" : "Geschlecht",
    "male" : "männlich",
    "female" : "weiblich",
    "birthday" : "Geburtstag",
    "phone" : "Handy",
    "region" : "Region",
    "ID" : "ID",
    "accountSetting" : "Kontoeinstellungen",
    "upgrade" : "Upgraden",
    "profile" : "Profil",
    "changePassword" : "Passwort ändern",
    "securityQuestion" : "Sicherheitsfragen",
    "creatework_headerTitle" : "Ticket erstellen",
    "mylist_headerTitle" : "Mein Ticket",
    "bindEmailTips" : "Überprüfen Sie Ihre E-Mail zur Sicherheit Ihres Kontos. Wenn Sie Ihr Passwort vergessen haben, senden wir Ihnen eine E-Mail an diese E-Mail-Adresse.",
    "verifyEmailTips" : "Wir haben festgestellt, dass sich Ihr Konto von einem neuen Gerät oder in einer ungewöhnlichen Umgebung anmeldet. Zum Schutz Ihrer Kontowerte schließen Sie bitte die Identitätsprüfung ab.",
    "enterEmailVrfcationTips" : "Bitte hier den Verifizierungscode eingeben.",
    "cancel" : "ABBRECHEN",
    "bindTps" : "Binden Sie Ihr Konto, um das Spiel auf mehreren Geräten zu spielen!",
    "login" : "Login",
    "logout" : "logout",
    "bind" : "Konto binden",
    "feedback" : "Feedback",
    "terms" : "Vereinbarungen",
    "tips" : "Ankündigung",
    "debindTips" : "Das Losbinden kann zu Datenverlust führen. Möchten Sie wirklich die Bindung aufheben?",
    "debindText" : "Losbinden",
    "guestSwitchTips" : "Gastkonto erkannt. Nach dem Login gehen Ihre Gastkonto-Daten verloren. Fortsetzen?",
    "register" : "anmelden",
    "realName" : "Echter Name",
    "enterEmailTips" : "Bitte Ihre E-Mail Adresse eingeben",
    "emailVAlidateMsg" : "Ungültige E-Mail",
    "editEmaileTips" : "Bitte Ihre E-Mail Adresse eingeben",
    "checkServiceTips" : "Bitte zuerst Nutzungsbedingungen und Datenschutzbestimmungen lesen.",
    "brithdayValidateTips" : "Ihren Geburtstag eingeben",
    "facebookValidateTips" : "Facebook-Konto (1 bis 60 Zeichen)",
    "eritOriginPwdTips" : "Originales Passwort",
    "submitSuccess" : "Submitted",
    "rebindEmail" : "Gebundene E-Mail ändern",
    "bindEmailSuccess" : "E-Mail gebunden: \$email</br>Bitte verwenden Sie eine gebundene E-Mail zur Verifizierung. Sie können Ihre E-Mail nach der Verifizierung zurücksetzen.",
    "reSetSecurityQuessoon" : "Sie haben die Sicherheitsfragen erfolgreich erstellt </br></br>Bitte verschiedene Fragen auswählen und verifizieren. Sie können die Fragen nach der Verifizierung wieder erstellen.",
    "canotModifyTips" : "Änderungen sind nach der Einreichung NICHT erlaubt, sicher einzureichen?",
    "rebindEmailTips" : "Ihre E-Mail :\$email,bitte tippen Sie hier, um Verifizierungscode zu erhalten",
    "reGetVrfCode" : "Code erhalten",
    "findPwdWayTips" : "Bitte eine der folgenden Weise auswählen",
    "emailWay" : "Per Sicherheits-E-Mail abrufen",
    "emailWayTips" : "Sie werden eine Bestätigungs-E-Mail erhalten und können das Passwort zurücksetzen",
    "quessionWay" : "Durch Sicherheitsfragen abrufen",
    "quessionWayTips" : "Beantworten Sie die erstellten Sicherheitsfragen und setzen Sie das Passwort zurück",
    "resetPwdBtn" : "Das Passwort zurücksetzen",
    "lastStep" : "Vorherig",
    "sendEmailTips" : "Wir haben Ihnnen eine E-Mail an \$email gesendet.<br>Bitte den Verifizierungscode hier eingeben.",
    "setNewPwdTips" : "Glückwünsche!<br>Benutzeridentität bestätigt. Jetzt können Sie Ihr Passwort zurücksetzen.",
    "termsOfUse" : "Nutzungsbedingungen",
    "copy_success" : "Kopiert",
    "creatework_create" : "Ticket",
    "creatework_createHolder" : "Typ auswählen",
    "creatework_title" : "Thema",
    "creatework_titleHolder" : "Bitte ein Thema eingeben",
    "creatework_detail" : "Details",
    "creatework_detailHolder" : "Beschreibung muss mehr als 200 Zeichen enthalten",
    "creatework_uploadTips" : "Bitte nur jpg/png Dateien hochladen. Hochgeladete Datei muss kleiner als 5 MB.",
    "creatework_selectBox_selectTile" : "Typ",
    "creatework_goGame" : "Zurück",
    "creatework_history" : "Geschichte",
    "mylist_noYet" : "Kein Rekord",
    "mywork_solved" : "Problem gelöst?",
    "mywork_service" : "Bewerten uns",
    "mywork_messageHolder" : "Neue Nachricht",
    "mywork_score" : "Score",
    "mywork_confirm" : "BESTÄTIGEN",
    "creatework_selectBox_selectList3" : "Sonstiges",
    "creatework_selectBox_selectList2" : "Konto",
    "close" : "Schließen",
    "creatework_gameHolder" : "Spiel auswählen",
    "creatework_serverHolder" : "Wähle Server",
    "contactService" : "Kontaktieren KS",
    "FAQ" : "FAQ",
    "creatework_game" : "Spiel:",
    "creatework_server" : "Server:",
    "creatework_role" : "Charakter:",
    "selectRoleName" : "Charakter auswählen",
    "creatework_noRole" : "Kein Charakter",
    "creatework_noGame" : "Spieleliste ist leer",
    "creatework_noServer" : "Serverliste ist leer",
    "termText" : "Ich stimme {mainHost} zu",
    "backLogin" : "ABBRECHEN",
    "creatework_roleHolder" : "Bitte Charakter zuerst auswählen",
    "findPwdFailTips" : "Sie haben die Sicherheitsfragen nicht eingestellt. Bitte kontaktieren Sie Kundendienst.",
    "payMall" : "Laden",
    "selectPayment" : "Anzahl",
    "plzSelectPayWay" : "Wähle Kanal",
    "gainPlus" : "Hinzufügen",
    "gainMorePlus" : "Mehr",
    "gainMostPlus" : "Max.",
    "plzSelectPayType" : "Zahlungsmethode auswählen",
    "roleName" : "Charaktername",
    "payWay" : "Zahlungskanal",
    "plzSelectOtherWay" : "Alternativer Zahlungskanal",
    "payment" : "Betrag",
    "compensateTips" : "Der Überschussbetrag wird Ihnen in \$gameCode zurückgegeben",
    "extaGain" : "Bonus",
    "gameGold" : "In-Game-Währung",
    "compensate" : "Entschädigung",
    "payWayPlus" : "Kanal-Bonus",
    "neddPay" : "Zahlung",
    "submitOrder" : "Senden",
    "screenshotTips" : "Hinweis: Mache im Falle eines Transaktionsfehlers einen Screenshot deiner Bestellung.",
    "storeFail" : "Failed to recharge",
    "storeFailTips" : "Transaktion fehlgeschlagen. Bitte senden Sie die Bestellung erneut oder kontaktieren Sie unseren Kundenservice.",
    "storeAcceptance" : "Wird bearbeitet",
    "storeSuccessTips" : "Die Transaktion erfolgt in 15 Minuten.",
    "orderNumber" : "Bestellnr.",
    "buyProduct" : "Gegenstand aufladen",
    "transactionAmount" : "Betrag",
    "failReason" : "Ursache",
    "payOntherORder" : "Neue Bestellung",
    "reStore" : "Wieder aufladen",
    "confirm" : "Bestätigen",
    "switch" : "Konto wechseln",
    "completeTips" : "Bitte geben Sie Ihre persönlichen Daten ein. <mark class=\"yellowMarkColor\">Informationen können nicht mehr bearbeitet werden</mark>. Wenn Sie versuchen, ein verlorenes Konto abzurufen, werden Sie aufgefordert, korrekte persönliche Informationen anzugeben.",
    "creatework_selectBox_selectList0" : "Spielfehler",
    "creatework_selectBox_selectList1" : "Zahlungsfehler",
    "creatework_selectBox_selectList4" : "Übersetzungsfehler",
    "mywork_solvedText" : "Problem gelöst",
    "browserPayErrBtnText" : "Zahlungsfehler",
    "browserPaySucBtnText" : "Zahlung abgeschlossen",
    "browserPayingTips" : "Weiterleitung an eine Drittanbieter-Plattform.<br/>Kann diese Seite nach der Bezahlung schließen.",
    "price_list_empty" : "Keine zutreffende Summe",
    "pointCardTips" : "Hinweis: Dieser Gegenstand unterstützt nur die \$paymentAmount Karte",
    "forgetPwd" : "Hast du dein Passwort vergessen?",
    "payCenter" : "Auflade-Zentrum",
    "willGet" : "Sie werden erhalten",
    "goods" : "Gegenstand",
    "discount" : "Bonus",
    "payDiscount" : "Entschädigung",
    "payDiscountTips" : "Der Überschussbetrag wird in der entsprechenden Währung zurückgegeben",
    "hasQuestionPlease" : "Wenn Sie Fragen haben, bitte",
    "pwdValidateMsg" : "6 bis 20 Zeichen",
    "payWayPlusC" : "Kanal-Bonus",
    "fwtk" : "NUTZUNGSBEDINGUNGEN",
    "yszc" : "DATENSCHUTZ-BESTIMMUNGEN",
    "exchange" : "Gutscheincode austauschen",
    "remember" : "meine Wahl merken",
    "thirdInfo" : "Über Konto",
    "thirdInfoContent" : "Bitte verbinden Sie das Konto im Benutzerzentrum im Spiel. Danach melden Sie sich mit dem gebundenen Konto im Spiel an.",
    "unLink" : "Diese Methode wird derzeit nicht unterstützt",
    "favour" : "Lesezeichen",
    "goStoreTip" : "Bitte geh zur Zahlungsseite weiter",
    "go" : "Gehen",
    "otherLogin" : "Andere Anmeldemethoden",
    "qrCodeTip" : "Scanne den QR-Code und geh los!",
    "favourTip" : "Setze ein Lesezeichen auf die Seite, um sie später wieder zu spielen!",
    "share" : "Teilen",
    "landscapeTip" : "Bitte mit Portraitmodus fortsetzen",
    "leaveTip" : "Das Spiel verlassen?",
    "selectRole" : "Bitte wähle Charakter",
    "selectMoney" : "Bitte wähle Objekt",
    "seletGameInfoFirst" : "Bitte Spiel auswählen",
    "lowerIE" : "IE version too old",
    "linkTermText" : "I have accepted {mainHost} [Terms of Use] and [Privacy Policy]",
    "download" : "Download",
    "favourAndDownloadTip" : "Bookmark this page to browser or download on PC",
    "payReward" : "Recharge Reward",
    "hasEqualReward" : "Double bonus for both payment methods",
    "payBtnText" : "Payment",
    "storeHoaveReward" : "Recharge Bonus",
    "showMorePayWay" : "More Methods",
    "needPaymentCount" : "Amount",
    "orderDetail" : "Details",
    "selectPayWayPlz" : "Choose payment",
    "countryCode" : "Country code",
    "deleteaccount_title1" : "Delete Account",
    "deleteaccount_title2" : "Request account deletion",
    "deleteaccount_step1_1" : "Your account will be frozen for 14 days since the account deletion. After 14 days, your account will be permanently deleted. You will not be able to log in with other social accounts.",
    "deleteaccount_step1_2" : "You may revoke the deletion within the 14 days through the link below:",
    "deleteaccount_step1_3" : "Once deleted, you will not be able to restore your account information. You will not be compensated for any loss caused by account deletion.",
    "deleteaccount_step1_4" : "Are you sure you want to delete your account?",
    "deleteaccount_step2_1" : "Please confirm that you want to delete your account and character.",
    "deleteaccount_step2_2" : "Please type \\&quot;Delete\\&quot; to complete the deletion.",
    "deleteaccount_step3" : "Your account will be deleted in 14 days.",
    "accountrecovery_note" : "Note:",
    "accountrecovery_tips" : "You may only revoke account deletion during the 14-day frozen period.",
    "accountrecovery_Submitted2" : "Revocation submitted. Your account will be restored later.",
    "accountrecovery_Failed" : "Failed",
    "accountrecovery_Failed_1" : "Account status is normal. You may log in.",
    "accountrecovery_Failed_2" : "Character information not found.",
    "accountrecovery_success" : "Account restored",
    "account_normal" : "Account status is normal. No need to restore.",
    "account_unablerestore" : "Account has been deleted. Unable to restore.",
    "accountrecovery_roleHolder" : "Enter  your character name",
    "accountrecovery_headerTitle" : "Revoke Account Deletion",
    "guideTitle" : "Your purchase is not successful. Please contact our customer service.",
    "accountFix" : "Account Recovery",
    "inputAccount" : "Please enter the account name that you wish to recover",
    "applyForAccountFix" : "Account Recovery",
    "nonEnterItem" : "Information to add: Registration Date; Model Number; Device Name; Passport or ID Number, Contact E-mail; Please fill in the blanks",
    "resetOT" : "Time out, please submit the Review again",
    "addOT" : "Time out, please submit the Additional Information again",
    "errorPwd" : "Password has to be 6-20 characters, including letters, numbers, \".\", \"_\", \"@\"",
    "verifyAccount" : "Account info is missing, please check again.",
    "selectRegisterTime" : "Please choose your registration time.",
    "enterBindEmail" : "Please insert your verified email.",
    "enterUsedPhoneType" : "Please insert the model of your mobile phone.",
    "enterIdfaGpid" : "Please insert the UDID of your device.",
    "enterContactEmail" : "Incorrect format of Contact E-mail Address; Please re-enter",
    "confirmTermsPrivacy" : "Please read and agree to the service terms and privacy policy.",
    "enterRechargeRemark" : "Please insert your recharge record.",
    "uploadImg" : "Please upload an Image Scan of your ID, maximum size is 20MB",
    "selectIDType" : "Please select the type of your identification document.",
    "enterIDNum" : "Please insert your passport number or ID number.",
    "enterIP" : "Please insert the IP address you used for registration.",
    "enterQueryNum" : "Please enter Review ID",
    "enterQueryPwd" : "Please enter Review Password",
    "errorQueryItem" : "Incorrect Review ID or Password, please try again",
    "enterPassword" : "Please insert a new password.",
    "enterPasswordAgain" : "Please confirm your new password.",
    "enterPasswordNonSame" : "Inconsistent Password",
    "enterEmail" : "Please enter e-mail address",
    "sendSuccess" : "E-mail has been sent",
    "enterCode" : "Please enter the Verification Code",
    "errorCode" : "Incorrect verification code",
    "selectQuest" : "Please select a Security Question",
    "enterAnswer" : "Please enter the answer",
    "selectDifferQuest" : "Please select 3 Security Questions and answers",
    "addSuccess" : "Your information has been submitted.",
    "picFormt" : "Picture format must be jpg, png or gif",
    "countdownBefore" : "Reset Countdown",
    "countdownAfter" : "(The link will expire at 00:00:00, please submit your application again )",
    "uploadDone" : "Upload done",
    "uploadFail" : "Upload failed",
    "applySuccess" : "Application Approved",
    "applyFailed" : "Application Denied",
    "resetQuestAlterFailed" : "Failed to change security question.",
    "resetQuestError" : "Data input error.",
    "resetQuestNone" : "Inquiry order not found.",
    "resetQuestAltered" : "Security questions have been changed.",
    "illegalOperation" : "Illegal Operation",
    "queryNotExist" : "Inquiry number does not exist.",
    "queryPasswordError" : "Find Password Error",
    "auditing" : "Pending approval",
    "notPass" : "Denied",
    "suppleInformation" : "Submit supplementary information",
    "suppleInformationUnHandle" : "Supplementary information submitted, pending process.",
    "suppleInformationTimeout" : "Submit supplementary information timeout.",
    "repairedAccountSuccess" : "Account repair has been completed.",
    "repairedAccountLost" : "Account repair operation has failed.",
    "loginStateNone" : "Not logged in or session has expired.",
    "repairedAccountTimeout" : "Account repair duration has expired.",
    "changePasswordSucc" : "Password changed.",
    "emailSendFailed" : "Failed to send mail.",
    "emailSendLimit" : "The mailbox may not receive any more verification codes today.",
    "repairedAccountTimeout2" : "Illegal operation account repair duration has expired.",
    "emailCodeSended" : "E-mail verification code has been sent.",
    "alterSuccess" : "Change saved",
    "questionAlterSuccess" : "Security question has been changed.",
    "username" : "Account name",
    "code" : "Please enter the verification code here",
    "selectServiceType" : "Please select Service Type",
    "submitForm" : "Submit the Form",
    "apply" : "Apply",
    "reviewApplicationStatus" : "Review Application Status",
    "instantReviewOfTheStatus" : "Instant Review of the Status",
    "reviewStatus" : "Review Status",
    "backToLogin" : "Back to login",
    "previous" : "Previous",
    "applyDesc" : "Please enter the information so that we can help. You must fill in the blanks with a * . If such information was missing in your account, please enter \"None\".",
    "additionalServices" : "Additional Services",
    "resetSecurityEmail" : "Reset Security E-mail",
    "resetSecurityQuest" : "Reset Security Questions",
    "registrationDate" : "Registration Date",
    "month" : "Month",
    "year" : "Year",
    "emailBound" : "E-mail Bound",
    "modelNumber" : "Mobile model type;",
    "deviceName" : "Device Name",
    "provideRecharge" : "Please provide a detailed and complete Recharge Record, including Time, Method, Amount, Order Number, and Transaction ID for us to confirm.",
    "selectCountry" : "Region",
    "passportID" : "Passport/ ID",
    "upload" : "Upload",
    "del" : "delete",
    "pleaseUpload" : "Please upload an Image Scan of your ID, with maximum size of 20MB",
    "uploadAgain" : "Upload again",
    "enterDesc" : "Please enter any information that proves the ownership of the account",
    "contactEmail" : "Contact E-mail",
    "applyNoteAttr" : "Note",
    "applyNoteDate" : "please provide your e-mail address so that you can receive the results of your application",
    "agree" : "I have agreed to",
    "UJOYTerms" : "Terms of Use",
    "privacy" : "Privacy Policy",
    "reviewStatusOfAccountFix" : "Review Status of Account Fix",
    "enterReviewID" : "Please enter Review ID",
    "enterReviewPwd" : "Please enter Review Password",
    "review" : "Review",
    "reviewNoteAttr" : "Note",
    "reviewNoteData" : "Check your Contact E-mail in case you forgot the Review ID and Review Password",
    "haveResetInfo" : "You\'ve reset your info",
    "resetProfile" : "Reset your Profile",
    "desc" : "Herzlichen Glückwunsch! Ihre Überprüfung wurde genehmigt. Bitte setzen Sie Ihre Informationen zurück.",
    "resetAccountDesc" : "Bitte beachten Sie: Sie müssen alle unten aufgeführten Wiederherstellungspunkte abschließen, um Ihr Konto zu entsperren.",
    "changePwd" : "Change Password",
    "resetPwd" : "Reset Password",
    "reset" : "Reset",
    "enterNewPwd" : "Please enter new password",
    "confirmNewPwd" : "Please confirm new password",
    "successResetPwd" : "Successfully Reset password",
    "bindSecurityEmail" : "Bind Security E-mail",
    "resetPwdDesc" : "Reset password when you forgot password or account was stolen",
    "bindCommon" : "Bind",
    "sendCommon" : "Send",
    "enterVcode" : "Please enter the Verification Code",
    "successResetEmail" : "Successfully Reset Security E-mail",
    "resetQuest" : "Reset Security Questions",
    "resetQuestDesc" : "Reset password when you forget your password or you believe your account info was stolen",
    "successResetQuest" : "Successfully Reset Security Questions",
    "hide" : "Hide",
    "addRegisterTime" : "Registration time;",
    "modelNum" : "Model Number: IDFA/GPID",
    "registrationIP" : "Registration IP;",
    "addRechargeRecord" : "Recharge record;",
    "serviceReply" : "Reply from Customer Service:",
    "addDataLimitTime" : "Date for Adding Addititional Information:",
    "addMoreInfo" : "Add More Information",
    "applicationSubmit" : "Application submitted",
    "underReviewStatus" : "Your profile is under review, you will get reply in the next working day. Review status:",
    "reviewID" : "Review ID",
    "reviePwd" : "Review Password",
    "enterReviewIDNPwd" : "Enter Review ID and Review Password to check status",
    "homepage" : "Homepage",
    "checkEmailAttr" : "Note",
    "checkEmailData" : "Check your Contact E-mail in case you forgot your Review ID and Review Password",
    "underReview" : "Under Review",
    "underReviewReply" : "Your profile is under review.We will reply as soon as possible. Thank you for your patience!",
    "failed" : "Application Failed",
    "reason" : "Reason: ### Therefore, application failed, please provide correct information, our staff will help. Thank you for your cooperation!",
    "underReviewAdd" : "Your profile is under review. Part of the information is missing or inconsistent, please add more information for us to confirm!",
    "addInfoRequired" : "Additional Information Required",
    "dateForAddInfo" : "Date for Adding Addititional Information:",
    "addInfo" : "Additional Information",
    "addInfoSubmit" : "Additional Information has been submitted! Thank you for your patience!",
    "hasBeenRepaired" : "Account has been repaired",
    "opExpired" : "Account repair operation expired",
    "approved" : "Approved",
    "haveSubmitted" : "You\'ve submitted",
    "sessionExpired" : "You\'ve not yet logged in or session value has expired",
    "submitted" : "Submitted",
    "addItemRegisterDate" : "E-mail;",
    "addItemDeviceNumber" : "UDID;",
    "reasonItemPwd" : "Inconsistent ID Number;",
    "addItemIDPhoto" : "ID Photo;",
    "idfaTitle" : "How to find your device IDFA or GPID?",
    "idfaSubTitle1" : "For ios user—finding your IDFA",
    "idfaSubTitle1Desc1" : "1.Download the app 【<em>MyIDFA</em>】from App Store",
    "idfaSubTitle1Desc2" : "2.Open this <em>app</em> and you will find your device <em>IDFA</em>.",
    "idfaSubTitle2" : "For Android user—finding your GPID",
    "idfaSubTitle2Desc1" : "1.tab the <em>“settings”</em> button",
    "idfaSubTitle2Desc2" : "2.tab the <em>“Google”</em> icon below the <em>ACCOUNTS</em> page",
    "idfaSubTitle2Desc3" : "3.then tab the <em>“Ads”</em> icon, and you will find your <em>GPID</em>",
    "uploadIDCard" : "Please upload an Image Scan of your ID, with maximum size of 20MB",
    "uploadTipsBefore" : "File size must not be greater than",
    "uploadTipsAfter" : "M",
    "submitError" : "Error caused by missing ID number or wrong account info.",
    "applyLimitError" : "Daily application limit exceeded. (3 times each day)",
    "applyDisabled" : "You may only submit once every 10 minutes.",
    "inputDataError" : "Data is not completed.",
    "dataException" : "Data exception",
    "picSizeLimit" : "Picture file size must not exceed 5MB",
    "picTypeLimit" : "Upload JPG, PNG, GIF files only",
    "picNull" : "Picture is empty",
    "alteredPassword" : "Password has been changed.",
    "inputError" : "Input error.",
    "pwdChangefailed" : "Failed to change password.",
    "sendEmailCodeDisabled" : "Verification code can only be sent again after a period of time.",
    "alteredEmail" : "E-mail has been changed.",
    "inputEmailError" : "E-mail input error",
    "operationFailed" : "Operation failed",
    "codeNull" : "You have not entered a verification code yet.",
    "findPwd" : "Forgot password",
    "findAccountAndPwd" : "Forgot account/password",
    "usualDeviceNum" : "Model Number: IDFA/GPID",
    "usualPhoneNum" : "Device Name",
    "registerTimeError" : "Inconsistent Registration Date;",
    "bindEMailError" : "Inconsistent Bound E-mail;",
    "rechargeRecordError" : "Inconsistent Recharge Record;",
    "registerIPError" : "Inconsistent Registration IP address;",
    "deviceNumError" : "Inconsistent IDFA/GPID;",
    "deviceModelError" : "Inconsistent Device Model;",
    "confirmTerms" : "Please agree to terms of service",
    "applyFixAccount" : "Wenn die obigen Ansätze nicht funktionieren, kannst du eine <span>Kontowiederherstellung</span>beantragen.",
    "findPwdByFixAccount" : "You are advised to set a security e-mail for account recovery.",
    "connectFail" : "Disconnected from Google Services, please try again",
    "h5_favour_has_gift" : "Bookmark to browser! (This account has claimed the reward already)",
    "h5_favour_get_gift" : "Congrats! You obtained the reward. Please check in-game.",
    "h5_get_gift_fault" : "Unable to claim. Please try again later, and contact our CS if the problem remains.",
    "h5_favour_please_select" : "Please choose server/character",
    "h5_favour_login_get" : "Log in and bookmark to the browser to claim a reward!",
    "h5_favour_tip" : "Bookmark to the browser to claim a reward!",
    "h5_favour_select_serve" : "Please choose server",
    "h5_favour_select_role" : "Please choose character",
    "store_product_paytype_error" : "You may not purchase the selected item through this payment method.",
    "SwitchWithThirdWay" : "Wechseln zu \${type}",
    "moreGame" : "Weitere Spiele",
    "serviceTitle" : "Service",
    "h5_download_login" : "Please log in first.",
    "h5_download_tips" : "Please start the game from the client.",
    "h5_download_repeat_get" : "You have claimed this giftpack.",
    "h5_download_succ" : "Please download the client first.",
    "h5_download_repeat_role" : "Character is bound",
    "currentLoginAccount" : "Current account:",
    "fb_canvas_fullscreen" : "Expand",
    "fb_canvas_website" : "Homepage",
    "fb_canvas_like_share" : "Share",
    "fb_canvas_service" : "Support",
    "fb_canvas_login_fail" : "Login failed",
    "fb_canvas_pay_return" : "You have cancelled the transaction",
    "fb_canvas_root_tip" : "Please log in Facebook to authorize first",
    "h5_popup_title" : "Payment way",
    "h5_popup_submit" : "Pay",
    "h5_popup_last_used" : "Last used",
    "h5_popup_quit_tips" : "Are you sure to cancel payment",
    "h5_popup_quit_check" : "YES",
    "h5_popup_quit_cancel" : "NO",
    "h5_popup_currency_sign" : "\$",
    "h5_popup_product_empty" : "Product information has not been obtained yet. Please refresh page",
    "h5_popup_server_empty" : "There is no server list yet. Please refresh page",
    "aboutRelevanceAccount" : "Already have an account?",
    "selectLoginType" : "Select a login method",
    "touristDescription" : "If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.",
    "touristSuggest" : "If you already have an account, you can log in as a guest and then tap the \"Switch Account\" option in the user center. From there, you can log in using a previously bound social media account.",
    "h5_tourist_remenber" : "Remember me for 14 days",
    "account_czsm1" : "1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；",
    "account_czsm2" : "2、引き継ぐ時のパスワードを登録してください。",
    "account_czsm3" : "3、セキュリティ保護のため、",
    "account_wzfdmm" : "大文字と小文字を区別して、6-16文字のパスワードをご入力",
    "account_qzcsrmm" : "再度パスワードをご入力",
    "account_fxyjm" : "引き継ぎコード発行",
    "account_yjmsm1" : "1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。",
    "account_yjmsm2" : "2、引き継ぎナンバーに使用期限はございません。",
    "account_yjmsm3" : "3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。",
    "account_yjmsm4" : "4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。",
    "account_fz" : "コピー",
    "account_cxfx" : "新規で発行する",
    "account_czsm4" : "アカウントを連携",
    "account_czsm5" : "してください。",
    "account_yjm" : "引き継ぎコード",
    "account_16wzzj" : "パスワードの長さは6～16文字にする",
    "account_qsrzqdyjmhmm" : "正しい引き継ぎコードとパスワードを入力してください。",
    "account_yj" : "引き継ぎ",
    "accoun_lcsrdmmbyz" : "パスワードの両回の入力は一致しない",
    "deleteaccount_step3_1" : "within the 14 days. Revoke now?",
    "account_syyjm" : "1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。",
    "account_yjmznsyyc" : "2. 引き継ぎコードは一度しか使えず、再発行することができます。",
    "account_sryjm" : "引き継ぎコードを入力",
    "account_srmm" : "パスワードを入力",
    "h5_header_gift" : "",
    "h5_award_popup_type" : "",
    "h5_award_popup_content" : "",
    "h5_award_popup_code" : "",
    "h5_favour_gift_name" : "",
    "h5_download_gift_name" : "",
    "h5_award_popup_exchange_way" : "",
    "h5_succ_get_gift" : "",
    "h5_exchange_info_title" : "",
    "h5_exchange_info_1" : "",
    "h5_exchange_info_2" : "",
    "h5_check_gift" : "",
    "account_delete_scdqzh" : "Willst du wirklich das Konto mit den dazugehörigen Daten löschen?",
    "account_delete_fwq" : "Server",
    "account_delete_zhm" : "Charakter",
    "account_delete_jshflj" : "Charakter Wiedererlangungslink",
    "account_delete_qzyzmdxx" : "(Groß- und Kleinschreibung beachten)",
    "account_delete_jtbcysxx" : "Es wird empfohlen, einen Screenshot der oben genannten Informationen zur Wiedererlangung des Kontos zu erstellen.",
    "deleteaccount_step3_2" : "After 14 days, your account will be deleted. You will not be able to restore your account. You will lose all your account information.\n\nYou may revoke the account deletion through",
    "h5_guest_login" : "Guest",
    "h5_click_copy" : "",
    "questionnaire_btn" : "Untersuchung des Fragebogens",
    "h5_header_store_text" : "Recharge",
    "h5_header_home_text" : "Homepage",
    "h5_check_gift_list_text" : "Belohnungs-Info",
    "yourServer" : "Dein Server",
    "allServer" : "Alle Server",
    "h5_header_screen" : "Vollbild",
    "h5_verticalTip" : "Querformatmodus wird empfohlen.",
    "h5_third_party_login_tips" : "If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.",
    "webStoreUidTitle" : "",
    "webStoreUidTips" : "",
    "webStoreUidGuide" : "",
    "webStoreUidInputt" : "",
    "feedbackTips" : "",
    "recentPlay" : "Kürzlich",
    "moreGames" : "Mehr",
    "previousSelect" : "Previous",
    "payAgainBtn" : "Top-up again",
    "packageTypeName" : "Pack",
    "coinTypeName" : "Top-up",
    "cardTypeName" : "Monthly Card",
    "orderNormal" : "Standard",
    "orderPriceUp" : "Price↑",
    "orderPriceDown" : "Price↓",
    "returnSelectRole" : "Return",
    "jiamaInfo" : "Zahlungsmethode-Bonus\nBonuswährung = Bezahlter Betrag * Währungskurs * Bonuskurs x Zahlungsmethode-Bonus\nBonuswährung = Bezahlter Betrag * Währungskurs * Bonuskurs\n*Hinweis: Die Bonuswährung wird nicht durch Auflade-Events oder VIP-EP gezählt.*Für Spiele, die weltweit eingeführt werden, wird der Zahlungsbetrag in US-Dollar berechnet.Bitte wende dich an den Kundendienst, wenn du Fragen hast.",
    "lastSelectTag" : "Used previously",
    "onestore_subscribe_manage" : "Manage",
    "onestore_subscribe_entrance" : "OneStore Subscription",
    "onestore_subscribe_has_expire" : "Expired",
    "onestore_subscribe_expire_time" : "Expire on \${month}/\${day}/\${year}",
    "onestore_subscribe_privacy" : "About Subscription and Privacy",
    "onestore_subscribe_cancel_subscribe" : "Cancel Subscription",
    "onestore_subscribe_info_title" : "Subscription Info",
    "onestore_subscribe_option_title" : "Options",
    "onestore_subscribe_do_not_subscribe" : "No subscribed items.",
    "onestore_subscribe_get_role_fail" : "Failed to subscribe. Please open this page again in the game.",
    "onestore_subscribe_later" : "Later",
    "onestore_subscribe_confirm" : "Confirm",
    "onestore_subscribe_confirm_cancel" : "Confirm Cancellation",
    "onestore_subscribe_popup_tip" : "If you cancel now, you can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_detail_tip" : "Subscribed item will be renewed on \${month}/\${day}/\${year} (Price: \${prices}/month). Subscription can be canceled 1 day before it expires.",
    "onestore_subscribe_expired_tip" : "Please subscribe the expired item from the in-game Mall/Shop",
    "onestore_subscribe_goon_sub" : "Renew on \${month}/\${day}/\${year}",
    "onestore_subscribe_has_cancel_tip1" : "Subscription canceled. You can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_has_cancel_tip2" : "If you wish to subscribe again. Please do so in the in-game Mall/Shop.",
    "onestore_subscribe_cancel_fail" : "Failed to cancel subscription. Please try again later.",
    "onestore_subscribe_cancel_fail_title" : "Cancel Subscription",
    "apple_deleteaccount" : "Delete Account",
    "apple_deleteaccount_title" : "Request account deletion",
    "apple_deleteaccount_step1_1" : "Please read the following terms and conditions carefully:",
    "apple_deleteaccount_step1_2" : "Your account will be frozen for 14 days since the account deletion.",
    "apple_deleteaccount_step1_3" : "Your account will be <span class=\"highlight\">permanently deleted</span> if you do not revoke the deletion process in 14 days. Upon deletion of your account, you will not be able to use it to log into the game. All information on your account will be deleted.",
    "apple_deleteaccount_step1_4" : "If you wish to unlink social media account from the account, please contact the customer service team for unlinking operation before deleting your account. Otherwise, upon successful deletion of your account, you will not be able to use your linked social media account to log into the game.",
    "apple_deleteaccount_step1_5" : "Please make sure you have properly disposed your virtual assets in the game before applying for the deletion of your account.<span class=\"highlight\">If you wish to apply for refund, please also do it before deleting your account</span>.",
    "apple_deleteaccount_step1_6" : "You may revoke the deletion within the 14 days through the link below, please save the link in advance:",
    "apple_deleteaccount_step2_1" : "Have you properly disposed your virtual assets in the game? If you haven\'t, please contact the customer service team for the matter before submitting an account deletion request.",
    "apple_deleteaccount_step2_2" : "Please save your server and character information which will be required for restoring your account.",
    "apple_deleteaccount_step2_3" : "Please type \"Delete\" to complete the deletion",
    "apple_deleteaccount_step3_1" : "Your account deletion request has been submitted. The following account is now frozen:",
    "apple_deleteaccount_step3_2" : "We will permanently delete your account after 14 days if there is no further request for revoking the deletion from you.",
    "apple_deleteaccount_step3_3" : "You can visit the following link to revoke the deletion within the 14 days period",
    "apple_deleteaccount_step4_1" : "You have deleted your old account. Please log in with a new account next time.",
    "apple_deleteaccount_agree" : "I have read and agree to the terms and conditions above",
    "apple_deleteaccount_server" : "Server",
    "apple_deleteaccount_roleName" : "Character",
    "copyLink" : "Copy Link",
    "copyTextAndImg" : "please copy and save the link or take a screenshot",
    "copyLinkAndRoleInfo" : "Copy Link & Character",
    "hasCopy" : "Copied to clipboard",
    "quickcard_tips" : "The information of your credit card has been encrypted and secured by Worldpay. The displayed information is only to provide a better experience.",
    "quickcard_use_new_card" : "New credit card",
    "edit" : "Edit",
    "save" : "Save",
    "quickcard_confirm_delete" : "Delete?",
    "quickcard_popup_tip" : "If you want to use this card again after deleting it, please choose the \"New credit card\" option.",
    "quickcard_result_tip_one" : "Wenn du dich dafür entscheidest, deine Kartennummer auf der vorherigen Seite zu speichern, würden wir die Daten deiner Karte (**** **** **** 1234) in verschlüsselter Version erfassen.",
    "quickcard_result_tip_two" : "Wir speichern verschlüsselte Details nur zu deiner Bequemlichkeit und du musst bei deinem nächsten Kauf keine Kartennummern eingeben.",
    "quickcard_learn_more" : "Learn more 》",
    "quickcard_info_title" : "Gespeicherte Zugangsdaten-Erklärung",
    "quickcard_info_tip_one" : "Um die Sicherheit der Kundendaten besser zu schützen, führen Visa und Mastercard neue Definitionen für diese „gespeicherten Zugangsdaten“ und neue Regeln für gespeicherte Zugangsdaten und vom Händler initiierte Transaktionen ein.",
    "quickcard_info_tip_two" : "Wenn du auf unserer Website einen Einkauf tätigst, erheben wir die Daten deiner Karte (1234 **** **** 1234) in verschlüsselter Form. Wir bewahren die verschlüsselten Daten 4 Jahre lang auf und werden die Vereinbarung und die Datenschutzerklärung auf unserer Website aktualisieren, falls sich Änderungen ergeben. Wir speichern verschlüsselte Daten nur zu deiner Bequemlichkeit und du musst bei deinem nächsten Einkauf keine Kartennummern eingeben.",
    "search_product" : "Finde Gegenstand",
    "search_price" : "Finde Preis",
    "price" : "Preis",
    "product_no_found" : "No items are found",
    "price_no_found" : "No price are found",
    "search_no_found" : "No items/price are found",
    "product" : "item",
    "store_tag_hot" : "HOT",
    "store_tag_discount" : "Discount",
    "store_tag_double" : "Double",
    "store_tag_treble" : "Treble",
    "store_tag_sale" : "SALE",
    "store_tag_top_seller" : "TOP SELLER",
    "store_tag_off_10" : "10%OFF",
    "store_tag_off_20" : "20%OFF",
    "store_tag_off_30" : "30%OFF",
    "store_tag_off_40" : "40%OFF",
    "store_tag_off_50" : "50%OFF",
    "store_tag_off_60" : "60%OFF",
    "store_tag_off_70" : "70%OFF",
    "store_tag_off_80" : "80%OFF",
    "store_tag_off_90" : "90%OFF",
    "store_tag_event" : "Event",
    "store_tag_daily" : "Daily",
    "store_tag_weekly" : "Weekly",
    "store_tag_monthly" : "Monthly",
    "subscriptionTypeName" : "subscription",
    "useDoubleSend" : "Use Box Multiplier?",
    "doubleSendInfo" : "Since you used a Box Multiplier, some of the items you purchased were doubled (as shown at the bottom)!",
    "storeRoleTitle" : "Bitte wähle Charakter",
    "storeSocialLogin" : "Mit SNS Konten einloggen",
    "storeAccountIdLogin" : "Mit Konto ID einloggen",
    "storeInputId" : "Enter account ID",
    "storeSearch" : "Suchen",
    "storeSelectProductTitle" : "Wähle Items aus",
    "storeInputNameSearch" : "Item Name eingeben und suchen",
    "storeInputPriceSearch" : "Item Preis eingeben und suchen",
    "storeNoFindProduct" : "Item nicht gefunden. Bitte erneut versuchen.",
    "storePriceUp" : "Preis↑",
    "storePriceDown" : "Preis↓",
    "storeLookDetail" : "Details",
    "storeChangeProduct" : "Item ändern",
    "storeWelcome" : "Willkommen",
    "storeLookMore" : "Mehr",
    "storeHasSelect" : "Item ausgewählt",
    "storeTotal" : "Gesamt",
    "storeExtra" : "Bonus",
    "storeProductDetail" : "Details",
    "storeUidGuideStep1" : "Tippe Einstellungen > Mehr > Konto",
    "storeUidGuideStep2" : "Konto ID eingeben beim Aufladen",
    "storeSelectAndLook" : "Bitte wähle zuerst dein Charakter",
    "storeSwitchWay" : "Loginmethode wechseln",
    "type1" : "Tägliches Angebot",
    "type2" : "Held",
    "type3" : "Kampfausrüstung",
    "type4" : "",
    "type5" : "Chip",
    "type6" : "Nova",
    "type7" : "Ressource",
    "type8" : "Bau Beschleunigen",
    "type9" : "Seltene Items",
    "type10" : "Allianz",
    "type11" : "Diamant",
    "type12" : "Modul",
    "type13" : "Kubus",
    "type14" : "",
    "type15" : "Nanowaffe",
    "type16" : "Endpreis",
    "type17" : "",
    "type9999" : "Begrenztes Angebot",
    "type10000" : "Geschenkzentrum",
    "type10001" : "Feiertags-Events",
    "typeother" : "Weitere Artikel",
    "switchChar" : "Charakter wechseln",
    "howToFindUid" : "Wie finde ich meine Konto ID?",
    "choosePayWay" : "Wähle eine Zahlungsmethode",
    "new_apple_deleteaccount_stepsub_title" : "Auto-Verlängerung abbrechen",
    "new_apple_deleteaccount_stepsub_1" : "Unter deinem Konto findest du ein Abonnement mit automatischer Verlängerung. Es wird empfohlen, die automatische Verlängerung zu stornieren, bevor du dein Konto löschst, um unbeabsichtigte Käufe zu vermeiden.",
    "new_apple_deleteaccount_stepsub_2" : "Auto-Verlängerung abbrechen",
    "new_apple_deleteaccount_stepsub_later" : "Später",
    "new_apple_deleteaccount_stepsub_now" : "Jetzt",
    "new_apple_deleteaccount_title" : "Kontolöschung beantragen",
    "new_apple_deleteaccount_step1_1" : "Bitte lies die folgenden Bedingungen sorgfältig durch:",
    "new_apple_deleteaccount_step1_2" : "Dein Konto wird nach  <span class=\"highlight\">dauerhaft gelöscht .</span> Du kannst es NICHT verwenden, um dich in das Spiel einzuloggen. Alle gelöschten Informationen deines Kontos können NICHT wieder aufgenommen werden.",
    "new_apple_deleteaccount_step1_3" : "Wenn du die Verknüpfung des Social-Media-Kontos mit dem Konto aufheben möchtest, wende dich bitte an den Kundendienst, um die Verknüpfung aufzuheben, bevor du dein Konto löschst. Andernfalls kannst du nach erfolgreicher Löschung deines Kontos dein verknüpftes Social-Media-Konto nicht verwenden, um dich beim Spiel anzumelden. Bitte stelle sicher, dass du deine virtuellen Assets im Spiel ordnungsgemäß entfernt hast, bevor du die Löschung deines Kontos beantragst.",
    "new_apple_deleteaccount_step1_4" : "<span class=\"highlight\">Wenn du eine Rückerstattung beantragen möchtest, veranlasse dies bitte auch, bevor du dein Konto löschst.</span> Bitte stelle sicher, dass du deine virtuellen Assets ordnungsgemäß entfernt hast, bevor du dein Konto löschst.",
    "new_apple_deleteaccount_step2_1" : "Hast du deine virtuellen Assets im Spiel ordnungsgemäß entfernt? Ist dies nicht der Fall, wende dich bitte an den Kundendienst, bevor du eine Anfrage zur Kontolöschung stellst.",
    "new_apple_deleteaccount_step2_2" : "Bitte gib „Delete“ ein, um den Löschvorgang abzuschließen. Eine einmal durchgeführte Kontolöschung kann nicht widerrufen werden.",
    "new_apple_deleteaccount_step2_3" : "Bitte gib „Delete“ ein, um den Löschvorgang abzuschließen.",
    "new_apple_deleteaccount_step3_1" : "Dein Antrag auf Kontolöschung wurde übermittelt. Das folgende Konto wurde inzwischen gelöscht:",
    "new_apple_deleteaccount_step3_2" : "Bitte erstelle ein neues Konto, wenn du dich erneut beim Spiel anmelden möchtest.",
    "new_apple_deleteaccount_step4_1" : "Du hast dein altes Konto gelöscht. Bitte melde dich beim nächsten Mal mit einem neuen Konto an.",
    "currencyTypeName" : "Währung",
    "has_select_product" : "Deine Items:",
    "n_product" : "\${n}",
    "look_detail_product" : "Alle anzeigen",
    "limit_buy_product" : "Kauflimit für dieses Item: \${n}",
    "limit_order" : "Du kannst jeweils nur maximal \${n} Items kaufen.",
    "limit_order_remove_tip" : "Du hast das Kauflimit für einige Items in diesem Warenkorb erreicht. Möchtest du sie entfernen?",
    "paytype_limit" : "Diese Zahlungsmethode kann nicht verwendet werden, um einige deiner Items zu kaufen. Bitte wähle eine andere Zahlungsmethode oder versuche, sie separat zu kaufen.",
    "check_remove_cart" : "Vom Warenkorb entfernen?",
    "remove_cart" : "Entfernen",
    "confirm_product" : "Bestätigen",
    "select_paytype" : "Zahlungsmethode auswählen",
    "cart_is_empty_tip" : "Keine Items gefunden. Bitte wähle zuerst ein Item aus.",
    "thirty_tip" : "Wenn die von dir gekauften Items nicht innerhalb von 30 Minuten ankommen, wende dich bitte an unseren Kundendienst.",
    "total_n_product" : "Item x\${n}",
    "look_detail_of_cart" : "Alle anzeigen",
    "order_detail" : "Item Liste",
    "total_detail" : "Anzahl:",
    "add_to_cart" : "In den Warenkorb",
    "back_to_select" : "Zurück",
    "fail_and_later" : "Item info error. Please try again later.",
    "nextStep" : "Bestätigen",
    "pnsGameName" : "Puzzles & Survival",
    "enterOfficial" : "Besuche \nWebseite",
    "visitorLogin" : "Gast",
    "tokenLogin" : "Einmalpasswort",
    "fbLogin" : "Mit Facebook einloggen",
    "googleLogin" : "Mit Google einloggen",
    "twitterLogin" : "Mit Twitter einloggen",
    "vkLogin" : "Mit VK einloggen",
    "agreementTextStart" : "Indem du dich beim Spiel einloggst, bestätigst du, dass du die Nutzungsbedingungen und die Datenschutzrichtlinie gelesen hast und ihnen zustimmst.",
    "userCenter" : "Benutzer Zentrum",
    "welcomeBack" : "Willkommen zurück",
    "continueGame" : "START",
    "officialPay" : "Aufladezentrum",
    "changeAccount" : "Konto wechseln",
    "back" : "Zurück",
    "tokenKey" : "Einmalpasswort",
    "inputUid" : "Gib deine UID ein.",
    "inputToken" : "Gib dein Einmalpasswort ein.",
    "inputCkCode" : "Gib den Text ein.",
    "enterGame" : "START",
    "tokenTip" : "Schütze dein Konto mit Einmalpasswort-Verifizierung.",
    "howToGetToken" : "Wie erhalte ich mein Einmalpasswort?",
    "getStep1" : "Schritt 1: Geh zu Einstellung > Konto > Benutzer Zentrum.",
    "getStep2" : "Schritt 2: Tippe auf Einmalpasswort.",
    "getStep3" : "Schritt 3: Kopiere und gib deine UID und das Einmalpasswort ein.",
    "copy" : "Kopieren",
    "lastRefresh" : "Aktualisiert in:",
    "second" : "s",
    "immediatelyRefresh" : "Jetzt aktualisieren",
    "frequently" : "Durchführung zu oft. Bitte versuche es später erneut.",
    "loginFail" : "Login fehlgeschlagen. Falsches Passwort.",
    "tokenIntro" : "Über Einmalpasswort (OTP)",
    "tokenIntro1" : "1. Einmalpasswörter laufen in 120 Sekunden ab. Verwende sie mit Bedacht, um dein Konto sicher zu halten.",
    "tokenIntro2" : "2. Die Mitarbeiter von werden dich nicht nach deinem Einmalpasswort fragen. Bitte teile oder gib dein Passwort niemals weiter.",
    "nextStep1" : "Bestätigen",
    "couponCanUse" : "Verwendbar",
    "couponCanNotUse" : "Nicht verwendbar",
    "couponHasNoCoupon" : "Keine Gutscheine",
    "couponUseTip" : "Verwende 1 Gutschein für jede Bestellung.",
    "couponValidTime" : "Gültigkeit",
    "couponFuilCanUse" : "Verwendbar für Bestellungen über  \${price} \${currency}",
    "couponNoLimit" : "Keine Einschränkungen",
    "couponAllProductCanUse" : "Keine Gegenstände",
    "couponPartProductCanUse" : "Bestimmte Gegenstände",
    "couponPartPaytypeCanUse" : "Bestimmte Zahlungskanäle",
    "couponOnlyCoinCanUse" : "Nur für Spielwährung.",
    "couponOnlyDiamondCanUse" : "Nur für Diamanten.",
    "couponOnlyPackageCanUse" : "Nur für Pakete.",
    "couponOnlySubCanUse" : "Nur für Abonnements.",
    "couponOnlyDaibiCanUse" : "Nur für Token.",
    "couponMaxDiscount" : "Rabatt bis zu \${price} \${currency}",
    "couponHasUsed" : "Verwendet",
    "couponReductionType" : "Abzug",
    "couponDiscountType" : "Rabatt",
    "couponUseNow" : "Verwenden",
    "couponHasNoSelect" : "Gutschein nicht verwenden.",
    "couponHasSelectQuan" : "Ermäßigt",
    "couponSubmitTip" : "Gutscheine werden verwendet.",
    "couponCanUseQuan" : "Gutscheine",
    "couponOrderTotal" : "Gesamt",
    "couponHasDiscount" : "Rabatt",
    "couponPayTotal" : "Zahlung",
    "couponCancel" : "Abbrechen",
    "couponConfirm" : "Bestätigen",
    "uidLoginName" : "Mit Einmalpasswort einloggen",
    "uidToken" : "Einmalpasswort",
    "uidInputUid" : "Gib deine UID ein.",
    "uidInputToken" : "Gib dein Einmalpasswort ein.",
    "uidInputCode" : "Gib den Text ein.",
    "uidTipTitle" : "Schütze dein Konto mit Einmalpasswort-Verifizierung.",
    "uidTipHowToGet" : "Wie erhalte ich mein Einmalpasswort?",
    "uidTipStep1" : "Schritt 1: Geh zu Einstellung > Konto > Benutzer Zentrum.",
    "uidTipStep2" : "Schritt 2: Tippe auf Einmalpasswort.",
    "uidTipstep3" : "Schritt 3: Kopiere und gib deine UID und das Einmalpasswort ein.",
    "uidTipIntro1" : "1. Einmalpasswörter laufen in 60 Sekunden ab. Verwende sie mit Bedacht, um dein Konto sicher zu halten.",
    "uidTipIntro2" : "2. Die Mitarbeiter von werden dich nicht nach deinem Einmalpasswort fragen. Bitte teile oder gib dein Passwort niemals weiter.",
    "couponMyQuan" : "Gutscheine",
    "couponSelectPaytypeTip" : "Wähle den Zahlungskanal aus, um Rabattinformationen anzuzeigen.",
    "couponSelectCouponTip" : "Wähle Gutscheine aus, um den ermäßigten Preis zu sehen.",
    "couponValidQuanTip" : "(Gutschein x\${num} verwendbar)",
    "couponLookCart" : "Warenkorb",
    "couponUnfoldCart" : "Ausblenden",
    "couponCoupon" : "Gutschein",
    "couponNoUse" : "Nicht verwenden",
    "couponSelect" : "Wähle Gutschein",
    "couponSureUse" : "Verwenden",
    "couponReturn" : "Zurück",
    "couponInvalidTime" : "Läuft ab",
    "couponBuyNow" : "Jetzt kaufen",
    "couponAllType" : "all",
    "ztmslgType1" : "Tägliches Angebot",
    "ztmslgType2" : "Held",
    "ztmslgType3" : "Kampfausrüstung",
    "ztmslgType4" : "",
    "ztmslgType5" : "Chip",
    "ztmslgType6" : "Nova",
    "ztmslgType7" : "Ressource",
    "ztmslgType8" : "Bau Beschleunigen",
    "ztmslgType9" : "Seltene Items",
    "ztmslgType10" : "Allianz",
    "ztmslgType11" : "Diamant",
    "ztmslgType12" : "Modul",
    "ztmslgType13" : "Kubus",
    "ztmslgType14" : "",
    "ztmslgType15" : "Nanowaffe",
    "ztmslgType16" : "Endpreis",
    "ztmslgType17" : "Kern",
    "ztmslgType9999" : "Begrenztes Angebot",
    "ztmslgType10000" : "Geschenkzentrum",
    "ztmslgType10001" : "Feiertags-Events",
    "ztmslgTypeother" : "Other",
    "antslgType1" : "Tägliche Verkauf",
    "antslgType2" : "Spezial-Ameise",
    "antslgType3" : "Ausrüstung",
    "antslgType5" : "Gen",
    "antslgType6" : "Schnecke",
    "antslgType7" : "Ressourcen",
    "antslgType8" : "Bauen & Erforschen",
    "antslgType9" : "Seltene Items",
    "antslgType10" : "Allianz",
    "antslgType11" : "Diamant",
    "antslgType12" : "Zelle",
    "antslgType13" : "Totem",
    "antslgType9999" : "Begrenztes Angebot",
    "antslgTypeother" : "other",
    "typeall" : "Alle Produkte",
    "vipHead" : "VIP-Punkte",
    "vipHead213": "Premium Mitgliedschaft",
    "vipTitle" : "VIP-Punkte Event",
    "nowLevel" : "Dein Level:",
    "myVipScore" : "Deine Pkt.:",
    "nextLevelNeed" : "(Verdiene \${num} Punkte mehr, um VIP \${level} zu erhalten.)",
    "ruleTitle" : "Regeln:",
    "ztmslgVipRule1" : "1. Das Event beginnt am 22/09/2022 um 00:00 Uhr (UTC).",
    "ztmslgVipRule2" : "2. Verfügbare Spiele:  Puzzles & Survival",
    "ztmslgVipRule3" : "Jede Art von Event-Belohnung kann nur einmal abgeholt werden.",
    "ztmslgVipRule4" : "3. Login-Coupon-Event: Wenn du dich zum ersten Mal auf der Aufladeseite anmeldest, kannst du einen Coupon mit einem Rabatt von 15% abholen.",
    "ztmslgVipRule5" : "4. VIP-Punkte-Event: Kaufe Gegenstände über unsere offizielle Seite, um Punkte zu sammeln und Level-Gutscheine und wöchentliche Gutscheine zu erhalten.",
    "ztmslgVipRule6" : "5. Die Punkte, die du sammeln kannst, können je nach verwendeter Währung variieren. Weitere Informationen findest du unter dem Link unten.",
    "ztmslgVipRule7" : "6. Wenn du Coupons verwendest, erhältst du Punkte basierend auf dem Betrag, den du bezahlt hast, nachdem die Coupons abgezogen wurden.",
    "ztmslgVipRule8" : "7. Die gesammelten Punkte verfallen nach 365 Tagen. Dies kann sich auf dein VIP-Level auswirken.",
    "ztmslgVipRule9" : "8. Du erhältst sofort einen Gutschein für das erstmalige Erreichen eines VIP-Levels. Der wöchentliche Gutschein kann jeden Samstag um 00:00 Uhr (UTC+0) eingelöst werden.",
    "ztmslgVipRule10" : "9. Du musst dich anmelden, um den wöchentlichen Gutschein zu erhalten. Nicht verpassen!",
    "ztmslgVipRule11" : "10. Die Währung des Gutscheins ist die Währung der letzten von dir getätigten Bestellung. Bitte wende dich an unseren Kundendienst, wenn du die von dir verwendete Währung ändern möchtest.",
    "ztmslgVipRule12" : "11. Weitere Einzelheiten zu den VIP-Level und Gutscheinen findest du in der folgenden Tabelle.",
    "ztmslgVipRule13" : "12. Im Falle von Streitigkeiten hat das Support-Team von Puzzles & Survival das alleinige und endgültige Ermessen über die Auslegung dieser Allgemeinen Geschäftsbedingungen.",
    "vipLevel" : "VIP-Level",
    "vipCondition" : "Benötigte Pkt.",
    "firstSend" : "Geschenk zum Erreichen beim 1. Mal",
    "weeklySend" : "Wöchentlicher Gutschein",
    "lastAllCoupon" : "Gutscheine der vorherigen Stufe",
    "besides" : "Währung-/Punktetabelle:",
    "couponRatio" : "Währung-/Punkterate:",
    "backToPay" : "ZURÜCK",
    "quanGift" : "GUTSCHEIN",
    "quanGiftTips" : "Du hast abholbare(n) Gutschein(e)!",
    "antslgVipRule1": "Aufgrund eines Funktions-Updates wird das „VIP-Punkte“-Event demnächst eingestellt.",
    "antslgVipRule2": "Bitte achte darauf, die bei der Aktion „VIP-Punkte“ erhaltenen Coupons vor Ablauf ihrer Gültigkeit einzulösen.",
    "antslgVipRule3": "Eventzeit: 28.09.2024, 00:00:00 Uhr (UTC)",
    "antslgVipRule4": "Nach Abschluss des Events kannst du das Premium-Mitgliederzentrum besuchen, um weitere Vorteile zu erhalten:",
    "antslgVipRule5": "Schließe Quests ab, um Punkte zu sammeln, die du gegen Coupons, Spiel-Items und andere Belohnungen eintauschen kannst! Freue dich über exklusive Mitgliedervorteile und Verlosungen.",
    "antslgVipRule6": "Bleib dran für weitere Belohnungen und Events!",
    "dzgVipRule0" : "1. Das Event beginnt am 27/09/2022 um 00:00 Uhr (UTC).",
    "dzgVipRule1" : "1. Verfügbare Spiele:  \${gameName}",
    "dzgVipRule2" : "Jede Art von Event-Belohnung kann nur einmal abgeholt werden.",
    "dzgVipRule3" : "2. Login-Coupon-Event: Wenn du dich zum ersten Mal auf der Aufladeseite anmeldest, kannst du einen Coupon mit einem Rabatt von 15% abholen.",
    "dzgVipRule4" : "3. VIP-Punkte-Event: Kaufe Gegenstände über unsere offizielle Seite, um Punkte zu sammeln und Level-Gutscheine und wöchentliche Gutscheine zu erhalten.",
    "dzgVipRule5" : "4. Die Punkte, die du sammeln kannst, können je nach verwendeter Währung variieren. Weitere Informationen findest du unter dem Link unten.",
    "dzgVipRule6" : "5. Wenn du Coupons verwendest, erhältst du Punkte basierend auf dem Betrag, den du bezahlt hast, nachdem die Coupons abgezogen wurden.",
    "dzgVipRule7" : "6. Die gesammelten Punkte verfallen nach 365 Tagen. Dies kann sich auf dein VIP-Level auswirken.",
    "dzgVipRule8" : "7. Du erhältst sofort einen Gutschein für das erstmalige Erreichen eines VIP-Levels. Der wöchentliche Gutschein kann jeden Samstag um 00:00 Uhr (UTC+0) eingelöst werden.",
    "dzgVipRule9" : "8. Du musst dich anmelden, um den wöchentlichen Gutschein zu erhalten. Nicht verpassen!",
    "dzgVipRule10" : "9. Die Währung des Gutscheins ist die Währung der letzten von dir getätigten Bestellung. Bitte wende dich an unseren Kundendienst, wenn du die von dir verwendete Währung ändern möchtest.",
    "dzgVipRule11" : "10. Weitere Einzelheiten zu den VIP-Level und Gutscheinen findest du in der folgenden Tabelle.",
    "dzgVipRule12" : "11. Im Falle von Streitigkeiten hat das Support-Team von \${gameName} das alleinige und endgültige Ermessen über die Auslegung dieser Allgemeinen Geschäftsbedingungen.",
    "213dzgVipRule1" : "Aufgrund eines Funktions-Updates wird das „VIP-Punkte“-Event demnächst eingestellt.",
    "213dzgVipRule2" : "Bitte achte darauf, die bei der Aktion „VIP-Punkte“ erhaltenen Coupons vor Ablauf ihrer Gültigkeit einzulösen.",
    "213dzgVipRule3" : "Eventzeit: 19.08.2024, 08:00:00 Uhr (UTC)",
    "213dzgVipRule4" : "Nach Abschluss des Events kannst du das Premium-Mitgliederzentrum besuchen, um weitere Vorteile zu erhalten:",
    "213dzgVipRule5" : "Schließe Quests ab, um Punkte zu sammeln, die du gegen Coupons, Spiel-Items und andere Belohnungen eintauschen kannst! Freue dich über exklusive Mitgliedervorteile und Verlosungen.",
    "213dzgVipRule6" : "Bleib dran für weitere Belohnungen und Events!",
    "getReward" : "Exklusive Avatar Rahmen",
    "unbindEntry" : "Konto verknüpfen/Verknüpfung aufheben",
    "unbindApply" : "Verknüpfung aufheben",
    "unbindConfirmTitle" : "Bist du sicher, dass du die Verknüpfung des Kontos aufheben möchtest?",
    "unbindConfirmTip" : "Das Aufheben der Verknüpfung des Kontos kann dazu führen, dass Spielstände/Fortschritte verloren gehen.",
    "unbindConfirm" : "Verknüpfung trotzdem aufheben",
    "unbindExit" : "Verlassen",
    "unbindSucc" : "Kontoverknüpfung aufgehoben",
    "unbindFail" : "Die Verknüpfung deines Kontos konnte nicht aufgehoben werden. Bitte wende dich an unseren Kundendienst.",
    "unbindServiceTitle" : "Bitte beantrage einen manuellen Vorgang zum Aufheben der Verknüpfung.",
    "unbindContact" : "Kundendienst",
    "unbindServiceTip" : "Du kannst die Verknüpfung deines Kontos nicht aufheben. Bitte wende dich an unseren Kundendienst.",
    "antslgType15" : "Erbschaft",
    "shareEventTitle" : "Lade Freunde ein</br>Verdiene Belohnungen",
    "shareRule" : "Regeln",
    "awardBag" : "Meine Belohnung",
    "initiatorText" : "Ich bin ein Einladender.",
    "inviteeText" : "Ich bin ein Eingeladener.",
    "createCode" : "Einladungscode erstellen",
    "createCodeTip" : "Tippen, um einen Einladungscode zu erstellen.",
    "createLinkTip" : "Tippen, um einen Einladungslink zu erstellen.",
    "copyText" : "Kopieren",
    "shareCode" : "Einladungscode teilen",
    "twShare" : "",
    "fbShare" : "",
    "dcShare" : "",
    "seeAward" : "Belohnung anzeigen",
    "seeAwardTip" : "Bitte überprüfe deine Belohnungen in <span class=\"see-light\">VIP-Punkte</span> > <span class=\"see-light\">Mein Coupon</span>.",
    "inviteReward" : "Einladungsbelohnung",
    "inviteRewardTip" : "Der Einladende kann diese Belohnungen nur abholen, wenn jeder Eingeladene diese Ziele zum ersten Mal erreicht.",
    "overweightReward" : "Bonusbelohnung",
    "resetTip" : "Wird am letzten Tag jedes Monats um 00:00 Uhr zurückgesetzt.（UTC+0）",
    "rewardText1" : "Gesamtaufladung durch den Eingeladenen: \$9.99",
    "rewardText2" : "Gesamtaufladung durch den Eingeladenen: \$49.99",
    "rewardText3" : "Gesamtaufladung durch den Eingeladenen: \$99.99",
    "rewardText4" : "Erhalte 12% Rabatt-Gutschein x1 für je 5 eingeladene Spieler.",
    "rewardText5" : "Erhalte 15% RABATT-Gutschein x1, nachdem deine Eingeladenen insgesamt \$1,000 aufgeladen haben.",
    "invitationList" : "Meine Einladung",
    "refresh" : "Aktualisieren",
    "invitedTotal" : "Eingeladen: \${total}",
    "storedTotal" : "Gesamtaufladung: \${total} USD",
    "people" : "",
    "invitedPeople" : "Eingeladener",
    "invitedTime" : "Eingeladen",
    "got" : "Erreicht",
    "get" : "Nicht erreicht",
    "overlay" : "Stapelbar",
    "couponText" : "Coupon",
    "personalReward" : "Aufladebelohnung",
    "personalRewardText1" : "Gesamtaufladung erreicht \$9.99",
    "personalRewardText2" : "Gesamtaufladung erreicht \$49.99",
    "personalRewardText3" : "Gesamtaufladung erreicht \$99.99",
    "inputCode" : "Gib den Einladungscode ein.",
    "bindCode" : "Bestätigen",
    "bindSucc" : "Verknüpft",
    "codeTip1" : "Code existiert nicht.",
    "codeTip2" : "Einladungscode verknüpft",
    "copySucc" : "Erfolg!",
    "awardName" : "Belohnung",
    "getTime" : "Erhalten",
    "getCondition" : "Anforderung",
    "couponText1" : "6% RABATT-Coupon",
    "couponText2" : "8% RABATT-Coupon",
    "couponText3" : "10% RABATT-Coupon",
    "couponText4" : "12% RABATT-Coupon",
    "couponText5" : "15% RABATT-Coupon",
    "ruleText1" : "1. Startzeit des Events: 25/11/2022, 00:00 Uhr UTC",
    "ruleText2" : "2. Event-Spiel: Puzzles & Survival",
    "ruleText3" : "3. Event „Offizielle Aufladeseite teilen“: Teile diese offizielle Aufladeseite mit deinen Freunden und lade sie zum Aufladen ein. Wenn sie über diese Seite einen bestimmten Betrag aufladen, wirst du belohnt.",
    "ruleText4" : "4. Monatliche Belohnungen durch Zahlungen von Drittanbietern: Erreiche monatliche Teilen-Ziele, um Belohnungen zu gewinnen. Die Belohnungen für die das Teilen werden jeden Monat zurückgesetzt.",
    "ruleText5" : "5. Monatliche Belohnungen erfordern mindestens eine erfolgreiche Aufladezahlung auf der Drittanbieter-Webseite durch neue Spieler, die du eingeladen hast.",
    "ruleText6" : "6. Die monatlichen Belohnungen werden am ersten Tag jedes Monats zurückgesetzt. Dadurch werden auch alle Fortschritte des Vormonats zurückgesetzt.",
    "ruleText7" : "7. Der gutgeschriebene Coupon sollte durch Anmelden bei der Aufladeseite des Drittanbieters abgeholt werden. Du erhältst keinen weiteren Coupon, wenn dieser abgelaufen ist.",
    "ruleText8" : "8. Der Coupon verwendet die gleiche Währung, die du in früheren erfolgreichen Aufladungen verwendet hast.",
    "ruleText9" : "9. Du kannst den Einladungscode eines anderen Spielers nicht verwenden, wenn dieser deinen bereits verwendet hat.",
    "ruleTableTitle1" : "Regeln：",
    "ruleTableTitle2" : "VIP-Stufen und Coupons:",
    "ruleTableHead1" : "Aufladung-Anforderung",
    "ruleTableHead2" : "Belohnungen-Anforderung",
    "ruleTableHead3" : "Belohnungen",
    "ruleTableContent1" : "Lade 5 neue Spieler ein.",
    "ruleTableContent2" : "Eingeladene Spieler laden \$1.000 USD auf.",
    "errorTip" : "Vorgang fehlgeschlagen",
    "eventShareText1" : "Zeitlich begrenzte Angebote von Puzzles & Survival",
    "eventShareText2" : "Jede Menge Geschenke warten auf dich!",
    "cartDoubleTip" : "Kisten-Multiplikatoren werden nicht unterstützt.",
    "codeTip3" : "Nicht eingeloggt",
    "codeTip4" : "Fehlender Parameter",
    "codeTip5" : "Dein eigener Einladungscode kann nicht verknüpft werden.",
    "codeTip6" : "Einladungscode erstellt",
    "payWelfare" : "Auflade-Geschenk",
    "wallet" : "Geldbeutel",
    "myDiscount" : "Mein Coupon",
    "knowMore" : "Mehr",
    "backPay" : "Zurück",
    "curBalance" : "Guthaben",
    "pay" : "Aufladen",
    "changeCoin" : "Währung wechseln",
    "watchDesc" : "Details zeigen",
    "getMore" : "Hole mehr",
    "getDiscount" : "Hole deine Coupons ab.",
    "notOpenDiscountQuan" : "Keine Events. Bitte bleibe dran!",
    "abountZbit" : "Über \${Z-BIT}",
    "remain" : "Übrig:",
    "payRemain" : "Restbetrag nach Kauf:",
    "payRemainExpiry" : "Voraussichtlicher Restbetrag nach Zahlung: ${money} (Verfällt am 1. Januar 2026, bitte zeitnah einlösen)",
    "balanceNotEnoughExpiry" : "Guthaben nicht ausreichend (läuft am 1. Januar 2026 ab, Aufladung nicht möglich)",
    "balanceNotEnoggh" : "Nicht genug Guthaben. Bitte zuerst aufladen.",
    "goToPay" : "Aufladen",
    "chooseOtherPay" : "Andere Zahlungsmethoden",
    "payIntro" : "Aufladen-Details",
    "logRole" : "Charakter wählen",
    "chooseProduct" : "Items auswählen",
    "meAgree" : "Ich habe die Bedingungen gelesen und stimme ihnen zu.",
    "coinAgreeText" : "",
    "aboutCoin" : "",
    "coinsPayTokenLogin" : "Vor der Verwendung von \${Z-BIT} ist eine dynamische Überprüfung erforderlich.",
    "dl3dvnVipRule1" : "1. Verfügbare Spiele:  \${gameName}",
    "dl3dvnVipRule2" : "Jede Art von Event-Belohnung kann nur einmal abgeholt werden.",
    "dl3dvnVipRule3" : "2. Login-Coupon-Event: Wenn du dich zum ersten Mal auf der Aufladeseite anmeldest, kannst du einen Coupon mit einem Rabatt von 15% abholen.",
    "dl3dvnVipRule4" : "3. VIP-Punkte-Event: Kaufe Gegenstände über unsere offizielle Seite, um Punkte zu sammeln und Level-Gutscheine und wöchentliche Gutscheine zu erhalten.",
    "dl3dvnVipRule5" : "4. Die Punkte, die du sammeln kannst, können je nach verwendeter Währung variieren. Weitere Informationen findest du unter dem Link unten.",
    "dl3dvnVipRule6" : "5. Wenn du Coupons verwendest, erhältst du Punkte basierend auf dem Betrag, den du bezahlt hast, nachdem die Coupons abgezogen wurden.",
    "dl3dvnVipRule7" : "6. Die gesammelten Punkte verfallen nach 365 Tagen. Dies kann sich auf dein VIP-Level auswirken.",
    "dl3dvnVipRule8" : "7. Du erhältst sofort einen Gutschein für das erstmalige Erreichen eines VIP-Levels. Der wöchentliche Gutschein kann jeden Samstag um 00:00 Uhr (UTC+0) eingelöst werden.",
    "dl3dvnVipRule9" : "8. Du musst dich anmelden, um den wöchentlichen Gutschein zu erhalten. Nicht verpassen!",
    "dl3dvnVipRule10" : "9. Die Währung des Gutscheins ist die Währung der letzten von dir getätigten Bestellung. Bitte wende dich an unseren Kundendienst, wenn du die von dir verwendete Währung ändern möchtest.",
    "dl3dvnVipRule11" : "10. Weitere Einzelheiten zu den VIP-Level und Gutscheinen findest du in der folgenden Tabelle.",
    "dl3dvnVipRule12" : "",
    "dl3dvnVipRule13" : "12. Im Falle von Streitigkeiten hat das Support-Team von \${gameName} das alleinige und endgültige Ermessen über die Auslegung dieser Allgemeinen Geschäftsbedingungen.",
    "codeTip7" : "Der Code des Zielspielers kann nicht verwendet werden, da er bereits deinen verwendet hat.",
    "ruleText10" : "10. Die offizielle Verwaltung von Puzzles & Survival behält sich alle Rechte zur endgültigen Auslegung vor.",
    "payCoins" : "Aufladen-VIP-Punkt",
    "shareGift" : "Für Geschenke teilen",
    "attentionCoinUse" : "Note: The balance in each currency is handled separately.",
    "noPayWay" : "In der ausgewählten Region sind keine Zahlungsmethoden verfügbar. Bitte ändere die Region und versuche es erneut.",
    "dl3dtwVipRule1" : "1. Verfügbare Spiele:  \${gameName}",
    "dl3dtwVipRule2" : "Jede Art von Event-Belohnung kann nur einmal abgeholt werden.",
    "dl3dtwVipRule3" : "2. VIP-Punkte-Event: Kaufe Gegenstände über unsere offizielle Seite, um Punkte zu sammeln und Level-Gutscheine und wöchentliche Gutscheine zu erhalten.",
    "dl3dtwVipRule4" : "3. Die Punkte, die du sammeln kannst, können je nach verwendeter Währung variieren. Weitere Informationen findest du unter dem Link unten.",
    "dl3dtwVipRule5" : "4. Wenn du Coupons verwendest, erhältst du Punkte basierend auf dem Betrag, den du bezahlt hast, nachdem die Coupons abgezogen wurden.",
    "dl3dtwVipRule6" : "5. Die gesammelten Punkte verfallen nach 365 Tagen. Dies kann sich auf dein VIP-Level auswirken.",
    "dl3dtwVipRule7" : "6. Du erhältst sofort einen Gutschein für das erstmalige Erreichen eines VIP-Levels. Der wöchentliche Gutschein kann jeden Samstag um 00:00 Uhr (UTC+0) eingelöst werden.",
    "dl3dtwVipRule8" : "7. Du musst dich anmelden, um den wöchentlichen Gutschein zu erhalten. Nicht verpassen!",
    "dl3dtwVipRule9" : "8. Die Währung des Gutscheins ist die Währung der letzten von dir getätigten Bestellung. Bitte wende dich an unseren Kundendienst, wenn du die von dir verwendete Währung ändern möchtest.",
    "dl3dtwVipRule10" : "9. Weitere Einzelheiten zu den VIP-Level und Gutscheinen findest du in der folgenden Tabelle.",
    "dl3dtwVipRule11" : "10. Im Falle von Streitigkeiten hat das Support-Team von \${gameName} das alleinige und endgültige Ermessen über die Auslegung dieser Allgemeinen Geschäftsbedingungen.",
    "eventInviteSucc" : "Lade erfolgreich einen Freund ein.",
    "eventGainCondition" : "Anforderungen",
    "eventSuccInvite" : "Lade erfolgreich einen Freund ein.",
    "eventInviteGainOne" : "Gesamtaufladung durch \n(den) Eingeladenen: \$49.99",
    "eventInviteGainTwo" : "Gesamtaufladung durch \n(den) Eingeladenen: \$99.99",
    "eventFriendCode" : "Der Code deines Freundes:",
    "eventCheckBind" : "Verknüpfen?",
    "eventConfirm" : "Bestätigen",
    "eventCancel" : "Abbrechen",
    "eventBindSucc" : "Erfolgreich verknüpft!",
    "eventGainCoupon" : "Du hast einen Coupon erhalten.",
    "eventLookCoupon" : "Coupon anzeigen",
    "eventSuccBind" : "Erfolgreich verknüpft",
    "recaptchaTip" : "Bitte zuerst überprüfen",
    "completeRecaptcha" : "Bitte schließen Sie die Captcha-Verifizierung ab",
    "recaptchaExpired" : "Die Verifizierung ist abgelaufen, bitte erneut versuchen",
    "inputAccountName" : "Bitte gib das Konto ein, das du wiederherstellen möchtest",
    "pwaPayTip" : "Schneller Zugriff, bessere Erfahrung",
    "pwsInstall" : "Zum Startbildschirm hinzufügen",
    "ztmslgType999" : "Gutschein",
    "coinUseTips" : "Nach dem Kauf werden Gutscheine an dein Postfach im Spiel gesendet. Gutscheine können zum Kauf von Items in der Gutschein-Mall im Spiel verwendet werden. Gutscheine, die zum Kauf von Items verwendet wurden, werden auf deine Gesamtaufladung angerechnet.",
    "notice" : "Mitteilung",
    "popupConfirm" : "Bestätigen",
    "hideWithinWeek" : "7 Tage lang nicht mehr anzeigen.",
    "ztmslgProductOffTips" : "Wir haben viele Rückmeldungen zu den Änderungen an der Zahlungsseite erhalten, die am 13. März eingeführt werden soll. Als Reaktion darauf haben wir beschlossen, diese Änderungen zu streichen und uns auf die Verbesserung deines Einkaufserlebnisses zu konzentrieren. Wir schätzen deine Meinung und danken dir für dein Verständnis und deine Unterstützung. Solltest du noch weitere Fragen haben, zögere bitte nicht, dich an unseren Kundendienst zu wenden.",
    "couponTopLimit" : "Maximal abzugsfähige Beträge nach Währung.",
    "swsjpVipRule1" : "1. Das Event beginnt am 24/03/2023 um 00:00 Uhr (UTC).",
    "swsjpVipRule2" : "2. Verfügbare Spiele: \${gameName}",
    "swsjpVipRule3" : "Jede Art von Event-Belohnung kann nur einmal abgeholt werden.",
    "swsjpVipRule4" : "3. Login-Coupon-Event: Wenn du dich zum ersten Mal auf der Aufladeseite anmeldest, kannst du einen Coupon mit einem Rabatt von 15% abholen.",
    "swsjpVipRule5" : "4. VIP-Punkte-Event: Kaufe Gegenstände über unsere offizielle Seite, um Punkte zu sammeln und Level-Gutscheine und wöchentliche Gutscheine zu erhalten.",
    "swsjpVipRule6" : "5. Die Punkte, die du sammeln kannst, können je nach verwendeter Währung variieren. Weitere Informationen findest du unter dem Link unten.",
    "swsjpVipRule7" : "6. Wenn du Coupons verwendest, erhältst du Punkte basierend auf dem Betrag, den du bezahlt hast, nachdem die Coupons abgezogen wurden.",
    "swsjpVipRule8" : "7. Für bereits getätigte Käufe werden dir bereits Punkte gutgeschrieben.",
    "swsjpVipRule9" : "8. Die gesammelten Punkte verfallen nach 365 Tagen. Dies kann sich auf dein VIP-Level auswirken.",
    "swsjpVipRule10" : "9. Du erhältst sofort einen Gutschein für das erstmalige Erreichen eines VIP-Levels. Der wöchentliche Gutschein kann jeden Samstag um 00:00 Uhr (UTC+0) eingelöst werden.",
    "swsjpVipRule11" : "10. Du musst dich anmelden, um den wöchentlichen Gutschein zu erhalten. Nicht verpassen!",
    "swsjpVipRule12" : "11. Die Währung des Gutscheins ist die Währung der letzten von dir getätigten Bestellung. Bitte wende dich an unseren Kundendienst, wenn du die von dir verwendete Währung ändern möchtest.",
    "swsjpVipRule13" : "12. Im Falle von Streitigkeiten hat das Support-Team von \${gameName} das alleinige und endgültige Ermessen über die Auslegung dieser Allgemeinen Geschäftsbedingungen.",
    "beautyVipRule1" : "",
    "beautyVipRule2" : "",
    "beautyVipRule3" : "",
    "beautyVipRule4" : "",
    "beautyVipRule5" : "",
    "beautyVipRule6" : "",
    "beautyVipRule7" : "",
    "beautyVipRule8" : "",
    "beautyVipRule9" : "",
    "beautyVipRule10" : "",
    "beautyVipRule11" : "",
    "antslgType999" : "Gutschein",
    "passAskMods" : "Moderator fragen",
    "passAskModsTip" : "Stelle den Moderatoren Fragen zum Spiel.",
    "passService" : "Kundenanfragen",
    "passServiceTip" : "Bei Fragen zum Konto und Aufladung, wende dich bitte an unseren Kundendienst.",
    "passIKonw" : "OK",
    "passGoOn" : "Fortfahren",
    "voucherTitle" : "Offizielles Aufladezentrum",
    "voucherAddHome" : "Zum Desktop hinzufügen",
    "voucherAddHomeTipOne" : "Schnellere Zahlung, bessere Erfahrung",
    "voucherAddHomeTipTwo" : "Tippe in der Symbolleiste auf [Teilen].",
    "voucherAddHomeTipThree" : "Wähle [Zum Desktop hinzufügen]",
    "voucherLoginLook" : "Einloggen, um Angebote anzuzeigen.",
    "voucherSwitchRole" : "Charakter wechseln",
    "voucherCoupon" : "Coupon",
    "voucherVip" : "VIP-Punkt",
    "voucherMoreCoupon" : "Mehr Angebote",
    "voucherAccountId" : "Konto ID",
    "voucherOtp" : "OTP",
    "voucherOtherWayPay" : "Wähle eine andere Zahlungsmethode aus.",
    "voucherOtherLoginWay" : "Andere Methode ausprobieren",
    "voucherCouponActivity" : "Rabatte",
    "voucherActivityNotBegin" : "Event hat noch nicht begonnen.",
    "voucherGoCommunity" : "Erfahre mehr über die Aufladevorteile in der Community.",
    "voucherValidTime" : "Gültigkeit",
    "voucherLimitRegion" : "Nur für \${currency}",
    "voucherLiuyi" : "Keine Coupons verfügbar. Bitte achte auf zukünftige Events.",
    "voucherPay" : "Gutscheine kaufen",
    "voucherAbout" : "Über Gutscheine",
    "voucherChooseWay" : "Wähle Zahlungsmethode aus",
    "voucherMoreWay" : "Mehr Zahlungsmethoden",
    "voucherChooseCoupon" : "Coupon auswählen",
    "voucherHasChoose" : "Ausgewählt",
    "voucherMoneyInsufficient" : "Unzureichendes Guthaben",
    "voucherContact" : "Unzureichendes Guthaben. Bitte wende dich an unser Support-Team.",
    "voucherCouponTotal" : "Verfügbare Coupons",
    "voucherCouponTipGuide" : "Coupons können zur Zahlung verwendet werden, nachdem du den Zahlungskanal ausgewählt hast.",
    "voucherPaytypeNotSupport" : "Coupons sind für diesen Zahlungskanal nicht verfügbar.",
    "voucherTipSideOne" : "Gutscheine können gegen alle Spielpakete und Mehrwertdienste mit Ausnahme des Gutscheins selbst eingetauscht werden.",
    "voucherTipSideTwo" : "Bis zu 15% Rabatt",
    "voucherYue" : "Guthaben",
    "jpUidLoginName" : "",
    "jpUidToken" : "",
    "jpUidInputToken" : "",
    "pnsBook" : "Überlebensanleitung",
    "vipHeadText" : "Exklusiver VIP-Rahmen freigeschaltet.",
    "vipHeadGetText" : "Abholen",
    "vipHeadGotText" : "Abgeholt",
    "vipHeadGetTitle" : "Bestätigen",
    "vipHeadGetTip" : "Diese Belohnung kann nur einmal pro Konto abgeholt werden. Fortfahren?",
    "vipHeadAwardText" : "Elite-Kommandeur (Dauerhaft)",
    "vipHeadGetErrTip1" : "Fehlgeschlagen. Bitte versuche es erneut oder kontaktiere den Kundendienst.",
    "cartGuideTipNew" : "Add more items to use coupon",
    "newVipTitle" : "Aufladezentrum-VIP",
    "newVipLogin" : "EINLOGGEN",
    "newVipNowPoint" : "Punkte:",
    "newVipNextLevel" : "\${point} Punkte bis zum nächsten Level",
    "newVipUpgrade" : "UPGRADE",
    "newVipLevel" : "VIP Privilegien",
    "newVipTip" : "Coupons werden jeden Samstag um 00:00 Uhr (UTC) aktualisiert. Du erhältst diese, wenn du dich auf der offiziellen Aufladeseite anmeldest.",
    "newVipWeekly" : "Wöchentl. Geschenk",
    "newVipReachPoint" : "Anforderungen:",
    "newVipRuleInfo" : "Regeln:",
    "pleaseLang" : "Sprache auswählen",
    "reference" : "Bestellnummer",
    "saveToNext" : "Kreditkarteninformationen speichern.",
    "cardNum" : "Kartennummer",
    "expireTime" : "Gültig bis",
    "CVV" : "CVV",
    "pleaseCard" : "Kreditkartentyp",
    "howToPay" : "Wie möchtest du bezahlen?",
    "checkCard" : "Bitte überprüfe die Nummer deiner Karte.",
    "checkExpiryDate" : "Bitte überprüfe das Ablaufdatum deiner Karte.",
    "checkCVV" : "Bitte überprüfe CVV deiner Karte.",
    "addCard" : "Neu",
    "delete" : "Löschen",
    "deleteCardTips" : "Gespeicherte Kreditkarteninformationen löschen.",
    "confirmDelete" : "Ja, löschen",
    "cancelDelete" : "Abbrechen",
    "checkAllCardMsg" : "Bitte stelle sicher, dass du die richtige Kartennummer, das richtige Ablaufdatum und den CVV eingegeben hast.",
    "leaveCreditPageTips" : "Wenn du diese Seite jetzt verlässt, wird die Transaktion nicht abgeschlossen. Verlassen?",
    "sureToLeave" : "Verlassen",
    "continueToPay" : "Fortfahren",
    "pushTest" : "Benachrichtigungstest",
    "getNoticication" : "Keine Spielbenachrichtigungen erhalten?",
    "waitCheckResult" : "Bitte warte auf das Testergebnis.",
    "hadAbnormal" : "Es wurde eine Anomalie gefunden, die zu einem Benachrichtigungsfehler führen könnte.",
    "clickIntro" : "Tippe auf den Bericht, um die Behebung anzuzeigen.",
    "networkCheck" : "Netzwerktest",
    "noticeAuthorityCheck" : "Benachrichtigungszugriffstest",
    "noticeBtnCheck" : "Test der Benachrichtigungsleiste",
    "gmsCheck" : "Test des GMS-Dienstes",
    "batteryCheck" : "Test der Batterieoptimierungsliste",
    "pushServiceCheck" : "Test des Benachrichtigungsdienstes",
    "reCheck" : "Erneut testen",
    "noNoticeAuthorityTip" : "Auf diesem Gerät wurde kein Benachrichtigungszugriff gewährt. Gehe zu Systemeinstellungen – Benachrichtigungen, um dem Spiel Zugriff zu gewähren.",
    "noNoticeBtnTip" : "Die Benachrichtigungsleiste ist deaktiviert. Bitte aktiviere sie in den Systemeinstellungen.",
    "noBatteryTip" : "Das Spiel steht auf der Batterieoptimierungsliste. Möglicherweise erhältst du keine Benachrichtigungen. Bitte gehe zu Systemeinstellungen – Akku – Akkuoptimierung, um das Spiel zur Whitelist hinzuzufügen.",
    "noPushServiceTip" : "Benachrichtigungsserver nicht verbunden. Tippe auf [Verbinden], um den Dienst fortzusetzen.",
    "noNetworkTip" : "Deine aktuelle Netzwerkverbindung ist instabil.",
    "noGmsTip" : "Dein Gerät unterstützt keine GMS. Bitte benutze ein Gerät, das mit GMS kompatibel ist.",
    "pushConnectFail" : "Benachrichtigungsserver getrennt.",
    "pushConnectSucc" : "Benachrichtigungsserver verbunden.",
    "noGetPushTitle" : "Wenn du immer noch keine Benachrichtigung vom Spiel erhalten kannst, dann folge diesen Schritten:",
    "noGetPushContOne" : "1. Melde dich vom Spiel ab und dann erneut auf diesem Gerät an.",
    "noGetPushContTwo" : "2. Tippe auf „Benachrichtigungstest“, um zu prüfen, ob dein Gerät bei aktueller Nutzung die Testbenachrichtigung empfangen kann.",
    "noGetPushContThree" : "3. Wenn du die Testbenachrichtigung erhalten hast, aber immer noch keine anderen Benachrichtigungen erhalten kannst, dann melde dich bitte beim Spiel an, gehe zu Einstellungen – Benachrichtigungen und prüfe, ob alle Benachrichtigungen aktiviert sind.",
    "noGetPushContFour" : "4. Solltest du weiterhin keine Benachrichtigungen erhalten können, wende dich bitte an unseren Kundendienst.",
    "getPushSucc" : "Dein Gerät hat eine Testbenachrichtigung erhalten. Die Funktion funktioniert normal!",
    "allCheckSucc" : "Benachrichtigungstest durchgeführt. Es wurde keine Anomalie gefunden!",
    "pushCheck" : "Benachrichtigungs-test",
    "useDirectPay" : "Express-Checkout verwenden",
    "paypalFraudnetInfo" : "Sichere Zahlung per PayPal",
    "goToSetting" : "Einstellungen",
    "retry" : "Wiederholen",
    "connect" : "Verbinden",
    "canRebind" : "Du kannst die Verknüpfung erneut durchführen, nachdem du die Verknüpfung aufgehoben hast.",
    "agreePlatform" : "Ich stimme den \${service} und den \${private} zu.",
    "sendGameNews" : "Newsletter abonnieren",
    "canNotBindEmail" : "Sobald du die Verknüpfung aufgehoben hast, kannst du dich mit dieser E-Mail-Adresse nicht mehr einloggen.",
    "canNotBindPhone" : "Sobald du die Verknüpfung aufgehoben hast, kannst du dich mit dieser Handynummer nicht mehr einloggen.",
    "canChangeByEmail" : "Du kannst dich auf verschiedenen Geräten per E-Mail-Adresse anmelden.",
    "canChangeByPhone" : "Du kannst dich auf verschiedenen Geräten per Handynummer anmelden.",
    "loginSucc" : "Eingeloggt",
    "phoneHadBind" : "Die Handynummer ist bereits verknüpft. Damit einloggen?",
    "emailHadBind" : "Die E-Mail-Adresse ist bereits verknüpft. Damit einloggen?",
    "phoneNotBind" : "Die Handynummer ist noch nicht verknüpft. Ein neues Konto erstellen?",
    "emailNotBind" : "Die E-Mail-Adresse ist noch nicht verknüpft. Ein neues Konto erstellen?",
    "emailAccount" : "E-Mail-Konto",
    "phoneAccount" : "Handy-Konto",
    "phoneInputError" : "Ungültige Handynummer",
    "registerNewAccount" : "Anmelden",
    "secureTip" : "Tipps zur Kontosicherheit",
    "toTop" : "Oben anpinnen",
    "createNewWork" : "Neues Ticket",
    "serviceEvaluate" : "Service bewerten",
    "emailRemind" : "Benachrichtigungen",
    "isAgreeService" : "Wie gefällt dir unser Service?",
    "thankEvaluateTop" : "Danke für dein Feedback!",
    "inputValidEmail" : "Bitte gib eine gültige E-Mail-Adresse ein.",
    "replyWillRemind" : "Du erhältst eine Benachrichtigungs-E-Mail, sobald deine Frage beantwortet wurde. Erneut tippen, um dies zu deaktivieren.",
    "isCancelEmailRemind" : "Du erhältst keine Benachrichtigungs-E-Mail. Deaktivieren?",
    "reconfirmEmail" : "Bitte bestätige deine E-Mail-Adresse.",
    "confirmCanSubmit" : "Bestätige, um das Ticket einzureichen.",
    "serviceWillReply" : "Du wirst per E-Mail benachrichtigt, wenn der Kundendienst geantwortet hat.",
    "cancelEmailRemind" : "Benachrichtigungen deaktivieren?",
    "yes" : "Ja",
    "no" : "Nein",
    "inputWorkSearch" : "Suchen ...",
    "loading" : "Laden",
    "loadingError" : "Laden fehlgeschlagen. Bitte erneut laden ...",
    "noMore" : "Nichts mehr",
    "cancelToTop" : "Lösen",
    "evaluateOne" : "Sehr schlecht",
    "evaluateTwo" : "Schlecht",
    "evaluateThree" : "Neutral",
    "evaluateFour" : "Gut",
    "evaluateFive" : "Sehr gut",
    "confirmDelWorkTop" : "Dieses Ticket löschen?",
    "reRemindEmail" : "Benötigst du eine E-Mail-Benachrichtigung? Tippe einfach erneut auf die Schaltfläche [Benachrichtigungen].",
    "confirmWillReply" : "Bestätige, dass du damit einverstanden bist, per E-Mail benachrichtigt zu werden, wenn der Kundendienst geantwortet hat.",
    "thankEvaluateBottom" : "",
    "confirmDelWorkBottom" : "Ein gelöschtes Ticket kann nicht wiederhergestellt werden.",
    "morePurchaseWay" : "",
    "purchaseNeed" : "",
    "videoUploadSucc" : "Video wurde hochgeladen.",
    "videoUploadFail" : "Video konnte nicht hochgeladen werden.",
    "videoUploadLimit" : "Bitte lade MP4-Dateien mit einer Größe unter 400 MB und nicht länger als 2 Minuten hoch.",
    "imageUploadSucc" : "Bild wurde hochgeladen.",
    "imageUploadFail" : "Bild konnte nicht hochgeladen werden.",
    "uploading" : "Hochladen ...",
    "smartOrderCreate" : "Schnell-Ticket",
    "smartOrderSearch" : "Suchen",
    "smartOrderComing" : "Demnächst",
    "smartOrderContactService" : "Kundendienst",
    "smartOrderDetector" : "Assistent",
    "smartOrderDetect" : "Diagnose",
    "smartOrderDetecting" : "Diagnose",
    "smartOrderDetectTip" : "Während du das Spiel spielst, wurde ein Problem festgestellt. Bitte tippe auf „Diagnose“, damit wir es identifizieren können.",
    "smartOrderDetectTip2" : "Problem identifiziert. Bitte reiche ein Ticket ein, damit wir das Problem lösen können!",
    "smartOrderSubmit" : "Einreichen",
    "smartOrderIKnow" : "OK",
    "smartOrderConfirm" : "OK",
    "smartOrderLook" : "Zeigen",
    "smartOrderIsHelp" : "War dieser Artikel hilfreich?",
    "smartOrderInputQuestion" : "Notiere das Problem, auf das du gestoßen bist.",
    "smartOrderPleaseInpt" : "Eingabe",
    "smartOrderPleaseChoose" : "Wählen",
    "smartOrderStoreTime" : "Aufladezeit",
    "smartOrderInputOrder" : "Bitte Bestellnummer eingeben.",
    "smartOrderInputPrice" : "Bitte Bestellmenge eingeben.",
    "smartOrderNeedHelp" : "Wie kann ich dir helfen?",
    "smartOrderLookHelpTip" : "Du kannst dir die FAQ ansehen.",
    "smartOrderNoResult" : "Keine Ergebnisse. Bitte versuche es mit einem anderen Schlüsselwort.",
    "smartOrderUpdateTime" : "Letzte Bearbeitungszeit",
    "smartOrderSelectStoreTime" : "Aufladezeit auswählen",
    "smartOrderAtlestChoose" : "Bitte fülle mindestens eines aus.",
    "workHomeTitle": "Kundenservice-Center",
    "workHomeCurServer": "Aktueller Server",
    "workHomeSearchPlaceholder": "Geben Sie Stichwörter ein, um schnell Antworten zu finden",
    "workHomeSelfService": "Selbstbedienung",
    "workHomeAiService": "Intelligenter Kundenservice",
    "workHomeArtificialService": "Persönlicher Kundenservice",
    "workHomeServiceEntrance": "Wir sind gerne für Sie da",
    "pwaInstallAward" : "Verknüpfung hinzufügen",
    "getMasonry" : "Diamant abholen",
    "addToDrawerVisit" : "Fügt eine Verknüpfung hinzu, damit du es leicht wiederfinden kannst.",
    "immeAddToGet" : "Füge jetzt eine Verknüpfung hinzu, um begrenzte Belohnungen zu erhalten.",
    "add" : "Verknüpfung hinzufügen",
    "talkNextTime" : "Später",
    "chooseRoleGetGift" : "Wähle deinen Charakter aus, um Belohnungen zu erhalten.",
    "getGiftSuccess" : "Abgeholt. Sieh dir deine Belohnungen im Spiel an.",
    "dmaTitle" : "Personalisierte Werbung",
    "dmaTitleSub" : "(optional)",
    "newAdd" : "Neu",
    "smartDelete" : "Löschen",
    "wordLengthTip" : "(0-600 Charaktere)",
    "areaLimitSwitchRegion" : "Region wechseln",
    "areaLimitCurrentRegionCurrency" : "Aktuelle Region und Währung",
    "areaLimitRegion" : "Region:",
    "areaLimitCurrency" : "Währung:",
    "areaLimitNote" : "Hinweis:",
    "areaLimitSwitchLimitation" : "Jedes Konto kann einmal pro Jahr die Region wechseln.",
    "areaLimitPostSwitchCoupon" : "Sobald deine Region geändert wird, ändert sich die Währung der neuen Coupons entsprechend.",
    "areaLimitRemainingSwitches" : "Wechselversuche übrig: \${times}",
    "areaLimitNoRemainingSwitches" : "Keine Wechselversuche",
    "areaLimitUnableToSwitchThisYear" : "Du darfst die Region dieses Jahr nicht mehr wechseln.",
    "areaLimitCannotSwitch" : "Wechsel nicht möglich",
    "areaLimitNavigateToSwitch" : "Wechseln",
    "areaLimitConfirmSwitch" : "Bestätigen",
    "areaLimitPreSwitchRegionCurrency" : "Aktuelle Region und Währung",
    "areaLimitPostSwitchRegionCurrency" : "Neue Region und Währung",
    "areaLimitPostSwitchRestriction" : "Sobald dies gemacht wurde, kannst du dieses Jahr nicht mehr die Region wechseln.",
    "areaLimitUnusedZBitWarning" : "Du verfügst über ungenutztes Z-Bit, das nach dem Regionswechsel möglicherweise nicht mehr verwendet werden kann. Fortfahren?",
    "areaLimitConfirm" : "Bestätigen",
    "areaLimitCancel" : "Abbrechen",
    "areaLimitInconsistencyWarning" : "Deine Zugangsregion stimmt nicht mit deiner Zahlungsregion überein.",
    "areaLimitPromptToSwitch" : "Möchtest du die Region wechseln?",
    "areaLimitEnterZipCode" : "*Please enter your zipcode",
    "areaLimitEnterInvalid" : "Zipcode is invalid, please re-enter",
    "areaLimitTaxRateTips" : "Depending on your location, the tax rate may vary, the payment amount shall prevail",
    "areaLimitInfoCollect" : "For information collection protection, please refer to the Privacy Policy",
    "getAward" : "Belohnung abholen",
    "selectProductTitle" : "Item auswählen",
    "hotSuggest" : "Top",
    "inputKeywordSearch" : "Suchen ...",
    "lookProductContent" : "Details",
    "popupClose" : "Schließen",
    "productSwitch" : "Wechseln",
    "confirmBuy" : "Kaufen",
    "thinkLater" : "Später",
    "areaLimitConfirmRegion" : "Region bestätigen",
    "areaLimitContinuePay" : "Weiter bezahlen",
    "areaLimitSwitchLimitationTwice" : "Jedes Konto kann zweimal pro Jahr die Region wechseln.",
    "dtmslgVipRule1" : "1. Verfügbare Spiele:  \${gameName}",
    "dtmslgVipRule2" : "Jede Art von Event-Belohnung kann nur einmal abgeholt werden.",
    "dtmslgVipRule3" : "2. VIP-Punkte-Event: Kaufe Gegenstände über unsere offizielle Seite, um Punkte zu sammeln und Level-Gutscheine und wöchentliche Gutscheine zu erhalten.",
    "dtmslgVipRule4" : "3. Die Punkte, die du sammeln kannst, können je nach verwendeter Währung variieren. Weitere Informationen findest du unter dem Link unten.",
    "dtmslgVipRule5" : "4. Wenn du Coupons verwendest, erhältst du Punkte basierend auf dem Betrag, den du bezahlt hast, nachdem die Coupons abgezogen wurden.",
    "dtmslgVipRule6" : "5. Die gesammelten Punkte verfallen nach 365 Tagen. Dies kann sich auf dein VIP-Level auswirken.",
    "dtmslgVipRule7" : "6. Du erhältst sofort einen Gutschein für das erstmalige Erreichen eines VIP-Levels. Der wöchentliche Gutschein kann jeden Samstag um 00:00 Uhr (UTC+0) eingelöst werden.",
    "dtmslgVipRule8" : "7. Du musst dich anmelden, um den wöchentlichen Gutschein zu erhalten. Nicht verpassen!",
    "dtmslgVipRule9" : "8. Die Währung des Gutscheins ist die Währung der letzten von dir getätigten Bestellung. Bitte wende dich an unseren Kundendienst, wenn du die von dir verwendete Währung ändern möchtest.",
    "dtmslgVipRule10" : "9. Weitere Einzelheiten zu den VIP-Level und Gutscheinen findest du in der folgenden Tabelle.",
    "dtmslgVipRule11" : "10. Im Falle von Streitigkeiten hat das Support-Team von \${gameName} das alleinige und endgültige Ermessen über die Auslegung dieser Allgemeinen Geschäftsbedingungen.",
    "dtmslgType10010" : "TÄGLICHER RABATT",
    "dtmslgType10020" : "LIMITIERTES ANGEBOT",
    "dtmslgType10030" : "HELD",
    "dtmslgType10040" : "Ausrüstung",
    "dtmslgType10050" : "RUNE",
    "dtmslgType10060" : "TOTEM",
    "dtmslgType10070" : "HEILIGSTEIN",
    "dtmslgType10080" : "DRACHE",
    "dtmslgType10090" : "RESSOURCEN",
    "dtmslgType10100" : "BAUEN & TECH",
    "dtmslgType10110" : "SELTENE",
    "dtmslgType10120" : "Kriegsrüstung",
    "dtmslgType10130" : "DIAMANT",
    "dtmslgType10140" : "Gutschein",
    "dtmslgType2" : "Event-Paket",
    "dtmslgType3" : "Belohnungszentrum",
    "dtmslgType4" : "Pop-up-Paket",
    "dtmslgType5" : "Hauptbildschirm Paket",
    "dtmslgType20010" : "Black Friday Paket",
    "dtmslgType20021" : "5-Tage-Geschenk",
    "dtmslgTypeother" : "Other",
    "rightsIntro" : "",
    "213RightsIntro": "Aufgrund eines Funktions-Updates wird das „VIP-Punkte“-Event demnächst eingestellt.<br/>\n" +
        "Bitte achte darauf, die bei der Aktion „VIP-Punkte“ erhaltenen Coupons vor Ablauf ihrer Gültigkeit einzulösen.<br/>\n" +
        "Eventzeit: 19.08.2024, 08:00:00 Uhr (UTC)<br/>\n" +
        "Nach Abschluss des Events kannst du das Premium-Mitgliederzentrum besuchen, um weitere Vorteile zu erhalten:<br/>\n" +
        "Schließe Quests ab, um Punkte zu sammeln, die du gegen Coupons, Spiel-Items und andere Belohnungen eintauschen kannst! Freue dich über exklusive Mitgliedervorteile und Verlosungen.<br/>\n" +
        "Bleib dran für weitere Belohnungen und Events!",
    "263RightsIntro": "Aufgrund eines Funktions-Updates wird das „VIP-Punkte“-Event demnächst eingestellt.<br/>\n" +
        "Bitte achte darauf, die bei der Aktion „VIP-Punkte“ erhaltenen Coupons vor Ablauf ihrer Gültigkeit einzulösen.<br/>\n" +
        "Eventzeit: 28.09.2024, 00:00:00 Uhr (UTC)<br/>\n" +
        "Nach Abschluss des Events kannst du das Premium-Mitgliederzentrum besuchen, um weitere Vorteile zu erhalten:<br/>\n" +
        "Schließe Quests ab, um Punkte zu sammeln, die du gegen Coupons, Spiel-Items und andere Belohnungen eintauschen kannst! Freue dich über exklusive Mitgliedervorteile und Verlosungen.<br/>\n" +
        "Bleib dran für weitere Belohnungen und Events!",
    "goToRights" : "Gehe zum Premium-Mitgliederzentrum",
    "oldVipIntro" : "Bitte achte darauf, die bei der Aktion „VIP-Punkte“ erhaltenen Coupons vor Ablauf ihrer Gültigkeit einzulösen.",
    "pwa-20001" : "Bitte logge dich zuerst ein",
    "pwa-20002" : "Inkorrekter Parameter",
    "pwa-20003" : "Bitte bestimme einen Charakter.",
    "pwa-20004" : "Belohnungen konnten nicht gesendet werden. Bitte versuche es erneut oder wende dich an den Kundendienst.",
    "pwa-20005" : "Du hast die Belohnung bereits abgeholt.",
    "pwa-20100" : "Event noch nicht gestartet.",
    "pwa-20101" : "Das Event ist zu Ende.",
    "pwa-20102" : "Du kannst die Belohnungen noch nicht abholen.",
    "pwa-20103" : "Deine Belohnungen sind abgelaufen.",
    "pwa-1001" : "Ausführung zu oft.",
    "pwaCommon" : "Bitte versuche es später erneut!",
    "zipCodeSwitchZipCode" : "Switch ZIP Code",
    "zipCodeState" : "state",
    "zipCodeRate" : "rate",
    "-" : "-",
    "officialStore": "Offizielles Aufladezentrum",
    "headerSafeTip": "Sicher und risikofrei Sofortige Transaktion",
    "safeChecking": "... Scannen des aktuellen Zahlungsumfelds",
    "safeChecked": "Sicher in der Anwendung",
    "riskChecked": "Potenzielles Risiko erkannt, gehe mit Vorsicht vor.",
    "footerSafeTitle1": "Sicher",
    "footerSafeTitle2": "Bequem",
    "footerSafeTitle3": "Kostengünstig",
    "footerSafeTitle4": "Effizient",
    "footerSafeContent1": "Offizielles Aufladezentrum",
    "footerSafeContent2": "Unterstützt mehrere Zahlungsarten",
    "footerSafeContent3": "Rabattangebote, mehr zeitlich begrenzte Vorteile.",
    "footerSafeContent4": "Sofortige Transaktion, keine Verzögerung",
    "limitedTimeActivityTitle" : "Zeitlich begrenzte Vorteile",
    "limitedTimeActivityTime" : "Event-Dauer:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivityTaskProcess" : "(Aktuell \${curPay}/\${targetPay})",
    "limitedTimeActivityRateTips" : "(Wechselkurse können variieren, genaue Informationen findest du auf dieser Seite.)",
    "limitedTimeActivityNotAchieve" : "Nicht abgeschlossen",
    "limitedTimeActivityClaim" : "Beanspruchen",
    "limitedTimeActivityClaimed" : "Beansprucht",
    "limitedTimeActivityTimeLeft" : "Zeitlich begrenzt: \${days} T. \${hours} Std. \${minutes} Min. \${seconds} Sek.",
    "limitedTimeActivityRecord" : "Beanspruchung Aufzeichnung",
    "limitedTimeActivityAward" : "Belohnungen",
    "limitedTimeActivityGotTime" : "Zeit der Beanspruchung",
    "limitedTimeActivityGotRole" : "Charakter beansprucht",
    "limitedTimeActivityRule" : "Eventregeln",
    "limitedTimeActivity285Rule1" : "1. Event-Dauer:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivity285Rule2" : "2. Erledige während des Events zeitlich begrenzte Aufgaben, um Belohnungen zu erhalten. Die Aufgaben sind in wöchentliche und monatliche Aufgaben unterteilt:",
    "limitedTimeActivity285Rule3" : "(1) Wöchentliche Aufgaben: Jedes Konto ist auf die Erledigung einer wöchentlichen Aufgabe pro Woche beschränkt. Die Aufgabe wird jeden Montag um 0:00 Uhr zurückgesetzt.",
    "limitedTimeActivity285Rule4" : "Wöchentliche Anmeldeaufgabe: Melde dich innerhalb der begrenzten Zeit einmal auf der Aufladeseite der offiziellen Internetseite an.",
    "limitedTimeActivity285Rule5" : "Beliebigen Betrag aufladen: Innerhalb der begrenzten Zeit kannst du über die offizielle Internetseite beliebige Beträge aufladen.",
    "limitedTimeActivity285Rule6" : "(2) Monatliche Aufgaben: Jedes Konto ist auf eine monatliche Aufgabe pro Monat beschränkt, die am 1. jedes Monats um 0:00 Uhr zurückgesetzt wird.",
    "limitedTimeActivity285Rule7" : "Anmeldeaufgabe: Melde dich innerhalb der begrenzten Zeit einmal auf der Aufladeseite der offiziellen Internetseite an.",
    "limitedTimeActivity285Rule8" : "Kumulative Aufladeaufgabe: Lade innerhalb der begrenzten Zeit den erforderlichen Betrag auf, um einmalig eine Belohnung zu erhalten.",
    "limitedTimeActivity285Rule9" : "Hinweis: Aufgrund der langen Dauer des Events kann es zu Wechselkursschwankungen kommen. Den Aufladebetrag entnimmst du bitte dem auf der Seite angezeigten Betrag.",
    "limitedTimeActivity285Rule10" : "3. Wähle einen Charakter aus, bevor du eine Belohnung beanspruchst. Du findest deine Belohnungen im Spiel, nachdem du sie beansprucht hast.",
    "limitedTimeActivityClaimAward" : "Belohnungen beanspruchen",
    "limitedTimeActivityConfirmGot" : "Anspruch bestätigen",
    "limitedTimeActivityGetSucc" : "Anspruch erfolgreich",
    "limitedTimeActivityGetFail" : "Anspruch fehlgeschlagen. Bitte versuche es später erneut oder wende dich an den Kundendienst.",
    "limitedTimeActivityFrequent" : "Bitte vermeide häufige Aktionen.",
    "limitedTimeActivityLoginFirst" : "Bitte melde dich zuerst an.",
    "limitedTimeActivityWrongParam" : "Parameterfehler",
    "limitedTimeActivityOverTips" : "Das Event ist abgelaufen. Bitte aktualisiere die Seite.",
    "preRightsIntro" : "Aufgrund eines Funktions-Updates wird das „VIP-Punkte“-Event demnächst eingestellt.<br/>Eventzeit: \${offLineDate}<br/>Bitte achte darauf, die bei der Aktion „VIP-Punkte“ erhaltenen Coupons vor Ablauf ihrer Gültigkeit einzulösen.<br/>Nach Abschluss des Events kannst du das Premium-Mitgliederzentrum besuchen, um weitere Vorteile zu erhalten:<br/>Schließe Quests ab, um Punkte zu sammeln, die du gegen Coupons, Spiel-Items und andere Belohnungen eintauschen kannst! Freue dich über exklusive Mitgliedervorteile und Verlosungen.<br/>Bleib dran für weitere Belohnungen und Events!",
    "riskTipTitle" : "Vorsicht vor rechtswidrigem Verhalten und Betrug",
    "riskTipContent" : "Hallo,\n\nwir haben festgestellt, dass einige Spieler Aktionen durchführen, die die Spielbalance und Fairness stören. Häufige Verstöße sind:\n\n1. Nicht autorisierte Anzeigen veröffentlichen: Nicht autorisierte Anzeigen über den Chat im Spiel oder andere Kanäle teilen, z. B. Werbung für illegalen Ressourcenhandel oder nicht autorisierte Aufladungen.\n\n2. Cheats oder Skripte verwenden: Cheats, Skripte oder andere technische Mittel verwenden, um illegal an Ressourcen zu gelangen.\n\n3. Nicht autorisierte Einladungen: Während des Chats Einladungen senden, um Spieler über externe Kanäle (z. B. Line, Discord) zum Kontakt zu verleiten.\n\n4. Illegale Aufladungen: Werbung für inoffizielle Aufladungen mit ermäßigten Preisen, um Spieler anzulocken.\n\n5. Andere Betrügereien: Betrügerische Aktivitäten, z. B. Nachahmung offizieller Mitarbeiter.\n\nWir fordern alle Spieler dringend auf, ihre persönlichen Daten und Vermögenswerte zu schützen. Vertraue keinen rechtswidrigen oder betrügerischen Nachrichten. Diese Verstöße bergen erhebliche Risiken, darunter das Potenzial für Kontodiebstahl oder die Beteiligung an betrügerischen Aktivitäten. Bitte beachte, dass wir für Verluste, die aus diesen Aktionen resultieren, keine Entschädigung leisten.\n\nBei Konten, die sich so verhalten, ergreifen wir je nach Schwere und Auswirkung der Verstöße entsprechende Maßnahmen. Zu den Maßnahmen können unter anderem Verwarnungen, die Beschlagnahme illegaler Gewinne, vorübergehende Sperrungen oder dauerhafte Verbote gehören. Wenn du im Spiel auf verdächtiges Verhalten stößt, melde es bitte unserem Kundendienst. Wir werden den Vorfall so schnell wie möglich untersuchen und die erforderlichen Maßnahmen ergreifen. Vielen Dank für dein Verständnis und deine Unterstützung.",
    "linkValid": "Dieser Link ist abgelaufen",
    "-" : "-",
    "accountLabel": "Konto",
    "passwordLabel": "Passwort",
    "confirmPasswordLabel": "Passwort bestätigen",
    "confirmDeleteTitle" : "Möchtest du dein Konto und alle Charaktere wirklich löschen?",
    "confirmDeleteYes" : "Ja. Ich möchte mein Konto und alle Charaktere löschen.",
    "selectGame" : "Spiel wählen",
    "confirmDeleteNo" : "Nein. Ich möchte nur einen Charakter löschen. Mein Konto möchte ich behalten.",
    "delTermsTitle" : "Bitte lese die Voraussetzungen und Hinweise zur Kontolöschung sorgfältig durch.",
    "delCondTitle" : "1. Anforderungen an die Kontolöschung",
    "delCond1" : "(1) Bitte logge dich vor der Anwendung bei deinem Konto an. Wenn du dich nicht einloggen kannst, [stelle bitte zuerst dein Konto wieder her]. Bitte stelle sicher, dass das Spielkonto und der Charakter dir gehören.",
    "delCond2" : "(2) Bitte bestätige, dass dein Konto und dein Charakter <span>keine Sicherheitsrisiken</span> aufweisen, einschließlich ungelöster Beschwerden, Berichte, Untersuchungen, Entscheidungen oder Gerichtsverfahren (von dir oder gegen dich eingereicht).",
    "delCond3" : "(3) Bitte bestätige, dass dein Konto und dein Charakter <span>keine ausstehenden Zahlungen</span> aufweisen, einschließlich nicht erledigter Rückerstattungen oder aktiver Abonnements.",
    "delNoticeTitle" : "2. Hinweis zur Kontolöschung",
    "delNotice1" : "(1) Die Löschung dieses Spielkontos und der damit verbundenen Charaktere ist <span>dauerhaft und unumkehrbar</span>.",
    "delNotice2" : "(2) Bitte <span>begleiche alle ausstehenden Spielbestände</span>, einschließlich, aber nicht beschränkt auf Items, Währung und Abonnements, bevor du fortfährst, da diese bei der Kontolöschung dauerhaft gelöscht werden. Nach Schließung des Spielservers werden für gelöschte Konten oder Charaktere keine Rückerstattungen gewährt.",
    "delNotice3" : "(3) Durch die Löschung von Konto- und Charakterdaten werden auch alle zugehörigen Informationen entfernt oder anonymisiert. Du musst jedoch die mit Social-Media-Logins von Drittanbietern (z. B. Facebook) verbundenen Daten manuell trennen und verwalten.",
    "delNotice4" : "(4) Zum Schutz deiner Interessen gilt eine 14-tägige Sperrfrist (Bedenkzeit), während der du dich an den Kundendienst wenden kannst, um die Löschanforderung zu stornieren (außer bei abweichenden lokalen Bestimmungen).",
    "delNotice5" : "(5) Nach erfolgreicher Übermittlung wird dein Konto sofort gesperrt, die Datenlöschung kann jedoch bis zu einer Woche dauern. Nach Abschluss erhältst du eine E-Mail-Benachrichtigung.",
    "delFormConfirm1" : "Ich verstehe die Bedingungen und Konsequenzen einer Kontolöschung.",
    "delFormConfirm2" : "Für dieses Konto gibt es keine ausstehenden Berichte oder Rechtsstreitigkeiten.",
    "delForm" : "Ich habe die <a class=\"account-delete-link\" href=\"javascript:;\">Kontolöschungsvereinbarung</a> gelesen und stimme ihr zu.",
    "cannotDeleteMsgTitle" : "Konto kann nicht gelöscht werden.",
    "cannotDeleteMsg1" : "Dein Konto erfüllt nicht die Voraussetzungen zur Löschung:",
    "cannotDeleteMsg2" : "Du hast ungelöste Support-Tickets. Bitte löse diese, bevor du den Vorgang fortsetzt.",
    "cannotDeleteMsg3" : "Du hast ausstehende Erstattungen. Bitte begleiche diese, bevor du die Löschung deines Kontos beantragst.",
    "cannotDeleteMsg4" : "Dein Konto wird derzeit aufgrund von Spielerberichten oder Beschwerden überprüft. Bitte warte, bis die Überprüfung abgeschlossen ist, bevor du den Vorgang erneut fortsetzt.",
    "formCompleted" : "Ticket eingereicht",
    "formCheckMsg1" : "Dein Ticket wurde eingereicht. Bitte warte auf die Überprüfung und Antwort.",
    "formCheckMsg2" : "Du kannst den Ticketfortschritt unter <span class=\"account-delete-link\">Meine Tickets</span> überprüfen.",
    "delEmailMsg1" : "Nach der Löschung per E-Mail benachrichtigen?",
    "delEmailMsg2" : "Die Kontolöschung dauert aufgrund der Datenverarbeitung etwa eine Woche. Möchtest du nach Abschluss per E-Mail benachrichtigt werden?",
    "delEmailMsg3" : "Deine E-Mail-Adresse wird nur zu Benachrichtigungszwecken verwendet.",
    "delEmailConfirmYes" : "Ja, bitte benachrichtige mich per E-Mail.",
    "delEmailFill" : "Bitte gib deine E-mail-Adresse für die Benachrichtigung ein.",
    "delEmailConfirmNo" : "Nein, ich benötige keine E-Mail-Benachrichtigung.",
    "delCoolMsg1" : "Möchtest du ein Widerrufsrecht von 14 Tagen?",
    "delCoolMsg2" : "Während der 14-tägigen Bedenkzeit wird dein Konto gesperrt, aber du kannst jederzeit einen Antrag auf Abbruch der Löschung stellen. Nach 14 Tagen wird dein Konto gelöscht und kann nicht wiederhergestellt werden, wenn du den Abbruch nicht eingeleitet hast.",
    "delCoolMsg3" : "Wenn du dich gegen ein Widerrufsrecht entscheidest, wird dein Konto sofort nach Abschluss des Antrags gelöscht und kann nicht wiederhergestellt werden.",
    "delCoolConfirmYes" : "Ja, ich möchte ein 14-tägiges Widerrufsrecht.",
    "delCoolConfirmNo" : "Nein, jetzt löschen.",
    "delSecondCheckMsg1" : "Bist du sicher, dass du alle Kontoinhalte verwaltet hast und das Konto-Widerrufsrecht aktivieren möchtest? Nach der Aktivierung ist dein Konto nicht mehr zugänglich.",
    "delSecondCheckConfirmYes" : "Ja, jetzt aktivieren.",
    "delResMsg1" : "Dein Antrag auf Kontolöschung wurde übermittelt und das folgende Konto wurde gesperrt:",
    "gameName" : "Spielname:",
    "gameAccount" : "Spielkonto:",
    "delResMsg2" : "<span>Bitte mach einen Screenshot und speicher die obigen Kontoinformationen, da dies die einzige Bestätigung ist, wenn du dein Konto während des Widerrufsrechts wiederherstellen musst</span>.",
    "delResMsg3" : "Widerrufsrecht: 14 Tage. Verbleibende Zeit:",
    "delResMsg4" : "Um den Löschantrag während des Widerrufsrechts abzubrechen, klicke auf Support kontaktieren.",
    "copyAccountInfo" : "Kontoinformationen kopieren",
    "delResMsg5" : "Dein Antrag auf Kontolöschung wurde bearbeitet, und dein Konto wird derzeit gelöscht. Daher kannst du dich nicht mehr einloggen.",
    "delResMsg6" : "Aufgrund der großen Datenmenge, die bei der Löschung eines Kontos anfällt, wird dies einige Zeit in Anspruch nehmen. Daher werden nicht alle Spuren deines Kontos sofort gelöscht. Wir gehen davon aus, dass wir diesen Vorgang innerhalb von etwa einer Woche abschließen werden.",
    "delResMsg7" : "Wenn du zuvor eine E-Mail-Adresse für die Kündigung angegeben hast, werden wir eine E-Mail an diese Adresse senden.",
    "delResMsg8" : "Wenn du dich wieder in das Spiel einloggen möchtest, kannst du ein neues Konto anlegen.",
    "appleOption" : "App Store",
    "googleOption" : "Google Play",
    "otherOption" : "Andere Kanäle",
    "itemWrong" : "Bei deiner Eingabe ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    "delRegisterTime" : "Registrierungsdatum",
    "delDevice" : "Häufig verwendetes Gerät",
    "delIp" : "Häufig verwendete IP-Adresse",
    "delHistoryPayChannel" : "Historische Aufladekanäle",
    "delHistoryPayOrder" : "Bisherige Bestellnummern",
    "delDeleteReason" : "Grund zur Kontolöschung",
    "delPrevStep" : "Vorher",
    "delNextStep" : "Weiter",
    "delSecondCheckMsg2" : "Bist du sicher, dass du alle Kontoinhalte bearbeitet hast und nun mit der Kontolöschung fortfahren möchtest? Nach der Ausführung wird dein Konto nicht mehr zugänglich sein.",
    "pleaseFillIn" : "Bitte gib die folgenden Informationen an",
    "switchNewVersion": "Zu neuer",
    "switchNewVersionPlatform": "Zahlungsplattform wechseln",
    "updateVersionPopupContent": "Um eine reibungslose Spielleistung und die Unterstützung neuer Funktionen zu gewährleisten, empfehlen wir Ihnen, Ihr Gerätesystem zu aktualisieren, um ein stabileres Laufzeiterlebnis und eine optimierte Kompatibilität zu genießen.",
    selectTopupTips:"90% der Nutzer bevorzugen das offizielle Aufladezentrum",
    chuzhi: "Guthaben aufladen",
    selectMethods: "Zahlungsmethode",
    landscapeTip2: "Bitte drehen Sie Ihr Telefon in den Hochformat-Modus für eine bessere Erfahrung",
    v3LaunchFromDesktopAndRewardToMailbox: 'Please launch from the desktop\nSelect a character and the reward will be sent to your mailbox',
    ckoNotAvailable: 'Zahlungsdienst fehlerhaft, bitte später erneut versuchen.',
    ckoSubmitFail: 'Zahlung fehlgeschlagen. Bitte überprüfen Sie Ihre Daten oder verwenden Sie eine andere Karte. Falls bereits belastet, wird der Betrag auf das ursprüngliche Zahlungsmittel zurückerstattet.',
    gotoFinish: 'Zu erledigen',
    inAppPurchase: 'In-App-Kauf',
}